import heroDashboard from "../assets/caseStudies/case04-hero-bigdata.svg";
import fieldCampaign from "../assets/caseStudies/case04-field-campaign.jpg";
import samplingDiagram from "../assets/caseStudies/case04-tree-face-sampling.svg";
import irrigationTimeline from "../assets/caseStudies/case04-irrigation-timeline.png";

const DATA = {
  "id": "04",
  "title": "18,582個の気孔から、何が見える？",
  "lead": "測るだけで終わらせない。Open / Closed、Aperture、Pore Area、Short/Longを画像単位・1時間単位へ加工し、日射・温度・VPD・CO₂・灌水と同じ時間軸に統合しました。",
  "question": "大量の気孔データを、どの指標・どの粒度で整理すると、植物の1日の応答を読み解きやすくなるのか。",
  "field": {
    "date": "2026年1月21日",
    "window": "07:00–17:24",
    "sampling": "12時前は各樹の東面、12時過ぎは各樹の西面で、光が当たる葉を測定。ハウス内を東西のエリアに分けた比較ではありません。"
  },
  "totals": {
    "images": 538,
    "stomata": 18582,
    "open": 14038,
    "closed": 4544,
    "validMorphologyImages": 519,
    "relationshipImages": 489,
    "irrigationCycles": 20,
    "hourBins": 11
  },
  "downloads": {
    "hourly": "/downloads/case04-hourly-data.csv",
    "imageCorrelations": "/downloads/case04-image-level-correlations.csv",
    "hourlyRegressions": "/downloads/case04-hourly-regressions.csv",
    "metricComparison": "/downloads/case04-metric-comparison.csv",
    "aggregation": "/downloads/case04-aggregation-comparison.csv"
  },
  "workflow": [
    {
      "step": "01",
      "label": "RAW DETECTIONS",
      "value": "18,582気孔",
      "text": "画像ID・撮影時刻・Open / Closed・Aperture・Pore Area・Short/Longを気孔単位で保持。"
    },
    {
      "step": "02",
      "label": "QUALITY CHECK",
      "value": "14,038 Open",
      "text": "形状指標は開口部が有効に検出されたOpen気孔を対象。ClosedはOpen率の分母・分子へ使用。"
    },
    {
      "step": "03",
      "label": "IMAGE SUMMARY",
      "value": "519画像",
      "text": "各画像でOpen率と、Open気孔のAperture・Area・Short/Long中央値を算出。"
    },
    {
      "step": "04",
      "label": "TIME SYNC",
      "value": "環境1分値",
      "text": "撮影時刻に最も近い日射・温度・RH・VPD・CO₂を許容差2分以内で対応。"
    },
    {
      "step": "05",
      "label": "HOURLY SUMMARY",
      "value": "11時間帯",
      "text": "Open率は気孔数を合算。形状指標は画像別中央値を1時間内で平均。"
    },
    {
      "step": "06",
      "label": "COMPARE & MODEL",
      "value": "複数の見方",
      "text": "時系列・散布図・午前午後・回帰・粒度比較・灌水イベント解析を実施。"
    }
  ],
  "definitions": [
    {
      "key": "openRate",
      "label": "Open率",
      "unit": "%",
      "question": "何個がOpenか",
      "definition": "Open気孔数 ÷ 全検出気孔数 × 100"
    },
    {
      "key": "aperture",
      "label": "Stomatal Aperture",
      "unit": "µm",
      "question": "どれだけ開いているか",
      "definition": "開口部を楕円近似したときの短軸長"
    },
    {
      "key": "poreArea",
      "label": "Pore Area",
      "unit": "µm²",
      "question": "開口領域はどれくらいか",
      "definition": "セグメンテーションで検出した開口領域の面積"
    },
    {
      "key": "aspectRatio",
      "label": "Pore Aspect Ratio",
      "unit": "Short / Long",
      "question": "開口部の形はどうか",
      "definition": "短軸長 ÷ 長軸長。1に近いほど円形に近い"
    }
  ],
  "rows": [
    {
      "time": "07:00",
      "timeLabel": "07時台",
      "images": 81,
      "imagesWithOpen": 70,
      "stomata": 2017,
      "open": 498,
      "closed": 1519,
      "openRate": 24.6901,
      "aperture": 2.7059,
      "aperturePooled": 2.7896,
      "poreArea": 28.3572,
      "poreAreaPooled": 29.4638,
      "aspectRatio": 0.1877,
      "aspectRatioPooled": 0.1882,
      "solar": 143.1074,
      "temperature": 14.3432,
      "rh": 60.358,
      "vpd": 0.6479,
      "co2": 473.4198,
      "side": "east"
    },
    {
      "time": "08:00",
      "timeLabel": "08時台",
      "images": 84,
      "imagesWithOpen": 79,
      "stomata": 2512,
      "open": 1341,
      "closed": 1171,
      "openRate": 53.3838,
      "aperture": 2.8141,
      "aperturePooled": 2.8411,
      "poreArea": 27.7271,
      "poreAreaPooled": 27.4388,
      "aspectRatio": 0.2098,
      "aspectRatioPooled": 0.2105,
      "solar": 367.6524,
      "temperature": 19.1679,
      "rh": 65.8333,
      "vpd": 0.7579,
      "co2": 408.7143,
      "side": "east"
    },
    {
      "time": "09:00",
      "timeLabel": "09時台",
      "images": 41,
      "imagesWithOpen": 41,
      "stomata": 1262,
      "open": 1064,
      "closed": 198,
      "openRate": 84.3106,
      "aperture": 3.5802,
      "aperturePooled": 3.8695,
      "poreArea": 38.3886,
      "poreAreaPooled": 41.9681,
      "aspectRatio": 0.2479,
      "aspectRatioPooled": 0.2567,
      "solar": 412.1195,
      "temperature": 24.2317,
      "rh": 67.8049,
      "vpd": 0.9809,
      "co2": 409.7317,
      "side": "east"
    },
    {
      "time": "10:00",
      "timeLabel": "10時台",
      "images": 63,
      "imagesWithOpen": 63,
      "stomata": 2487,
      "open": 2382,
      "closed": 105,
      "openRate": 95.778,
      "aperture": 4.4998,
      "aperturePooled": 4.4415,
      "poreArea": 49.5313,
      "poreAreaPooled": 48.8025,
      "aspectRatio": 0.2963,
      "aspectRatioPooled": 0.2922,
      "solar": 559.7016,
      "temperature": 26.7095,
      "rh": 66.6032,
      "vpd": 1.176,
      "co2": 369.6667,
      "side": "east"
    },
    {
      "time": "11:00",
      "timeLabel": "11時台",
      "images": 33,
      "imagesWithOpen": 32,
      "stomata": 1227,
      "open": 1149,
      "closed": 78,
      "openRate": 93.643,
      "aperture": 5.0201,
      "aperturePooled": 5.0219,
      "poreArea": 57.6192,
      "poreAreaPooled": 59.94,
      "aspectRatio": 0.3256,
      "aspectRatioPooled": 0.3095,
      "solar": 636.1606,
      "temperature": 29.3061,
      "rh": 65.1667,
      "vpd": 1.4211,
      "co2": 388.1515,
      "side": "east"
    },
    {
      "time": "12:00",
      "timeLabel": "12時台",
      "images": 30,
      "imagesWithOpen": 30,
      "stomata": 1121,
      "open": 1043,
      "closed": 78,
      "openRate": 93.0419,
      "aperture": 5.7504,
      "aperturePooled": 6.39,
      "poreArea": 69.1504,
      "poreAreaPooled": 75.9375,
      "aspectRatio": 0.3519,
      "aspectRatioPooled": 0.3793,
      "solar": 660.6533,
      "temperature": 29.5033,
      "rh": 70.0667,
      "vpd": 1.2384,
      "co2": 353.1333,
      "side": "switch"
    },
    {
      "time": "13:00",
      "timeLabel": "13時台",
      "images": 41,
      "imagesWithOpen": 41,
      "stomata": 1967,
      "open": 1886,
      "closed": 81,
      "openRate": 95.8821,
      "aperture": 6.4828,
      "aperturePooled": 6.5416,
      "poreArea": 85.555,
      "poreAreaPooled": 86.8725,
      "aspectRatio": 0.3523,
      "aspectRatioPooled": 0.3499,
      "solar": 628.4024,
      "temperature": 33.7146,
      "rh": 63.2439,
      "vpd": 1.9175,
      "co2": 378.7073,
      "side": "west"
    },
    {
      "time": "14:00",
      "timeLabel": "14時台",
      "images": 41,
      "imagesWithOpen": 41,
      "stomata": 1523,
      "open": 1388,
      "closed": 135,
      "openRate": 91.1359,
      "aperture": 4.0779,
      "aperturePooled": 4.2817,
      "poreArea": 48.3209,
      "poreAreaPooled": 51.435,
      "aspectRatio": 0.2546,
      "aspectRatioPooled": 0.2661,
      "solar": 525.6439,
      "temperature": 31.0366,
      "rh": 71.3659,
      "vpd": 1.3214,
      "co2": 398.2683,
      "side": "west"
    },
    {
      "time": "15:00",
      "timeLabel": "15時台",
      "images": 66,
      "imagesWithOpen": 66,
      "stomata": 2739,
      "open": 2491,
      "closed": 248,
      "openRate": 90.9456,
      "aperture": 4.1353,
      "aperturePooled": 4.2691,
      "poreArea": 48.3768,
      "poreAreaPooled": 50.5238,
      "aspectRatio": 0.259,
      "aspectRatioPooled": 0.2674,
      "solar": 357.3803,
      "temperature": 25.7985,
      "rh": 74.697,
      "vpd": 0.8404,
      "co2": 400.303,
      "side": "west"
    },
    {
      "time": "16:00",
      "timeLabel": "16時台",
      "images": 50,
      "imagesWithOpen": 49,
      "stomata": 1471,
      "open": 747,
      "closed": 724,
      "openRate": 50.7818,
      "aperture": 3.1142,
      "aperturePooled": 3.182,
      "poreArea": 35.3879,
      "poreAreaPooled": 36.7537,
      "aspectRatio": 0.2002,
      "aspectRatioPooled": 0.1976,
      "solar": 181.654,
      "temperature": 22.366,
      "rh": 68.43,
      "vpd": 0.8453,
      "co2": 358.84,
      "side": "west"
    },
    {
      "time": "17:00",
      "timeLabel": "17時台",
      "images": 8,
      "imagesWithOpen": 7,
      "stomata": 256,
      "open": 49,
      "closed": 207,
      "openRate": 19.1406,
      "aperture": 2.8877,
      "aperturePooled": 2.7,
      "poreArea": 33.9549,
      "poreAreaPooled": 35.64,
      "aspectRatio": 0.175,
      "aspectRatioPooled": 0.1687,
      "solar": 0.0,
      "temperature": 16.7,
      "rh": 57.625,
      "vpd": 0.8142,
      "co2": 416.0,
      "side": "west"
    }
  ],
  "representative": [
    {
      "time": "07:00",
      "side": "east",
      "sideLabel": "午前｜樹の東面",
      "images": 81,
      "stomata": 2017,
      "open": 498,
      "closed": 1519,
      "openRate": 24.6901,
      "aperture": 2.7059,
      "apertureQ1": 2.3362,
      "apertureQ3": 3.0063,
      "poreArea": 28.3572,
      "poreAreaQ1": 22.313,
      "poreAreaQ3": 33.7669,
      "aspectRatio": 0.1877,
      "aspectRatioQ1": 0.1654,
      "aspectRatioQ3": 0.2034
    },
    {
      "time": "13:00",
      "side": "west",
      "sideLabel": "正午過ぎ｜樹の西面",
      "images": 41,
      "stomata": 1967,
      "open": 1886,
      "closed": 81,
      "openRate": 95.8821,
      "aperture": 6.4828,
      "apertureQ1": 5.5725,
      "apertureQ3": 7.3269,
      "poreArea": 85.555,
      "poreAreaQ1": 77.4562,
      "poreAreaQ3": 98.3137,
      "aspectRatio": 0.3523,
      "aspectRatioQ1": 0.2949,
      "aspectRatioQ3": 0.4008
    },
    {
      "time": "17:00",
      "side": "west",
      "sideLabel": "午後｜樹の西面",
      "images": 8,
      "stomata": 256,
      "open": 49,
      "closed": 207,
      "openRate": 19.1406,
      "aperture": 2.8877,
      "apertureQ1": 2.6726,
      "apertureQ3": 2.9734,
      "poreArea": 33.9549,
      "poreAreaQ1": 31.3116,
      "poreAreaQ3": 37.8675,
      "aspectRatio": 0.175,
      "aspectRatioQ1": 0.1523,
      "aspectRatioQ3": 0.2003
    }
  ],
  "scatter": [
    {
      "time": "07:00:21",
      "side": "east",
      "aperture": 2.8241,
      "poreArea": 29.565,
      "aspectRatio": 0.20253,
      "openRate": 2.941,
      "solar": 17.6,
      "temperature": 13.3,
      "rh": 58.0,
      "vpd": 0.6415,
      "co2": 479
    },
    {
      "time": "07:00:31",
      "side": "east",
      "aperture": 2.9775,
      "poreArea": 41.6138,
      "aspectRatio": 0.16199,
      "openRate": 18.421,
      "solar": 21.8,
      "temperature": 13.3,
      "rh": 56.0,
      "vpd": 0.6721,
      "co2": 491
    },
    {
      "time": "07:00:39",
      "side": "east",
      "aperture": 2.5179,
      "poreArea": 25.2112,
      "aspectRatio": 0.16522,
      "openRate": 11.538,
      "solar": 21.8,
      "temperature": 13.3,
      "rh": 56.0,
      "vpd": 0.6721,
      "co2": 491
    },
    {
      "time": "07:01:21",
      "side": "east",
      "aperture": 2.1488,
      "poreArea": 19.6931,
      "aspectRatio": 0.15387,
      "openRate": 16.667,
      "solar": 21.8,
      "temperature": 13.3,
      "rh": 56.0,
      "vpd": 0.6721,
      "co2": 491
    },
    {
      "time": "07:01:32",
      "side": "east",
      "aperture": 3.2695,
      "poreArea": 31.59,
      "aspectRatio": 0.17172,
      "openRate": 10.714,
      "solar": 25.2,
      "temperature": 13.3,
      "rh": 56.0,
      "vpd": 0.6721,
      "co2": 491
    },
    {
      "time": "07:01:39",
      "side": "east",
      "aperture": 2.1456,
      "poreArea": 23.7938,
      "aspectRatio": 0.13123,
      "openRate": 11.111,
      "solar": 25.2,
      "temperature": 13.3,
      "rh": 56.0,
      "vpd": 0.6721,
      "co2": 491
    },
    {
      "time": "07:02:01",
      "side": "east",
      "aperture": 2.6964,
      "poreArea": 25.515,
      "aspectRatio": 0.21436,
      "openRate": 17.391,
      "solar": 25.2,
      "temperature": 13.3,
      "rh": 56.0,
      "vpd": 0.6721,
      "co2": 491
    },
    {
      "time": "07:06:34",
      "side": "east",
      "aperture": 3.1749,
      "poreArea": 39.285,
      "aspectRatio": 0.20325,
      "openRate": 6.667,
      "solar": 47.0,
      "temperature": 13.1,
      "rh": 57.0,
      "vpd": 0.6483,
      "co2": 487
    },
    {
      "time": "07:06:52",
      "side": "east",
      "aperture": 2.9151,
      "poreArea": 28.7044,
      "aspectRatio": 0.16434,
      "openRate": 10.909,
      "solar": 47.0,
      "temperature": 13.1,
      "rh": 57.0,
      "vpd": 0.6483,
      "co2": 487
    },
    {
      "time": "07:07:56",
      "side": "east",
      "aperture": 2.2434,
      "poreArea": 18.225,
      "aspectRatio": 0.17274,
      "openRate": 18.519,
      "solar": 50.4,
      "temperature": 13.1,
      "rh": 57.0,
      "vpd": 0.6483,
      "co2": 487
    },
    {
      "time": "07:08:57",
      "side": "east",
      "aperture": 2.7043,
      "poreArea": 28.9069,
      "aspectRatio": 0.16711,
      "openRate": 14.286,
      "solar": 50.4,
      "temperature": 13.0,
      "rh": 57.0,
      "vpd": 0.644,
      "co2": 487
    },
    {
      "time": "07:09:40",
      "side": "east",
      "aperture": 3.1257,
      "poreArea": 33.9188,
      "aspectRatio": 0.22047,
      "openRate": 6.667,
      "solar": 52.9,
      "temperature": 13.0,
      "rh": 57.0,
      "vpd": 0.644,
      "co2": 487
    },
    {
      "time": "07:17:19",
      "side": "east",
      "aperture": 2.9639,
      "poreArea": 33.3113,
      "aspectRatio": 0.16711,
      "openRate": 34.286,
      "solar": 84.0,
      "temperature": 13.0,
      "rh": 60.0,
      "vpd": 0.5991,
      "co2": 487
    },
    {
      "time": "07:17:38",
      "side": "east",
      "aperture": 2.9871,
      "poreArea": 38.88,
      "aspectRatio": 0.17853,
      "openRate": 10.526,
      "solar": 89.9,
      "temperature": 13.0,
      "rh": 60.0,
      "vpd": 0.5991,
      "co2": 487
    },
    {
      "time": "07:18:09",
      "side": "east",
      "aperture": 2.25,
      "poreArea": 21.9713,
      "aspectRatio": 0.16594,
      "openRate": 27.273,
      "solar": 89.9,
      "temperature": 13.0,
      "rh": 60.0,
      "vpd": 0.5991,
      "co2": 487
    },
    {
      "time": "07:18:15",
      "side": "east",
      "aperture": 1.772,
      "poreArea": 12.9094,
      "aspectRatio": 0.14239,
      "openRate": 11.111,
      "solar": 89.9,
      "temperature": 13.0,
      "rh": 60.0,
      "vpd": 0.5991,
      "co2": 487
    },
    {
      "time": "07:18:21",
      "side": "east",
      "aperture": 2.2847,
      "poreArea": 29.2106,
      "aspectRatio": 0.12664,
      "openRate": 13.793,
      "solar": 89.9,
      "temperature": 13.0,
      "rh": 60.0,
      "vpd": 0.5991,
      "co2": 487
    },
    {
      "time": "07:18:26",
      "side": "east",
      "aperture": 1.952,
      "poreArea": 10.8338,
      "aspectRatio": 0.26136,
      "openRate": 15.789,
      "solar": 89.9,
      "temperature": 13.0,
      "rh": 60.0,
      "vpd": 0.5991,
      "co2": 487
    },
    {
      "time": "07:18:30",
      "side": "east",
      "aperture": 2.3545,
      "poreArea": 24.0975,
      "aspectRatio": 0.16949,
      "openRate": 12.5,
      "solar": 89.9,
      "temperature": 13.0,
      "rh": 60.0,
      "vpd": 0.5991,
      "co2": 487
    },
    {
      "time": "07:18:36",
      "side": "east",
      "aperture": 1.8774,
      "poreArea": 15.4406,
      "aspectRatio": 0.17404,
      "openRate": 22.222,
      "solar": 94.9,
      "temperature": 13.0,
      "rh": 60.0,
      "vpd": 0.5991,
      "co2": 487
    },
    {
      "time": "07:21:57",
      "side": "east",
      "aperture": 2.7,
      "poreArea": 26.2237,
      "aspectRatio": 0.19136,
      "openRate": 20.635,
      "solar": 111.7,
      "temperature": 13.1,
      "rh": 60.0,
      "vpd": 0.603,
      "co2": 479
    },
    {
      "time": "07:22:06",
      "side": "east",
      "aperture": 2.9753,
      "poreArea": 38.6269,
      "aspectRatio": 0.15915,
      "openRate": 4.0,
      "solar": 111.7,
      "temperature": 13.1,
      "rh": 60.0,
      "vpd": 0.603,
      "co2": 479
    },
    {
      "time": "07:22:19",
      "side": "east",
      "aperture": 2.621,
      "poreArea": 19.3388,
      "aspectRatio": 0.15862,
      "openRate": 25.0,
      "solar": 111.7,
      "temperature": 13.1,
      "rh": 60.0,
      "vpd": 0.603,
      "co2": 479
    },
    {
      "time": "07:32:06",
      "side": "east",
      "aperture": 2.8193,
      "poreArea": 26.2744,
      "aspectRatio": 0.20871,
      "openRate": 73.333,
      "solar": 158.8,
      "temperature": 13.6,
      "rh": 61.0,
      "vpd": 0.6075,
      "co2": 479
    },
    {
      "time": "07:35:11",
      "side": "east",
      "aperture": 3.0215,
      "poreArea": 41.31,
      "aspectRatio": 0.1581,
      "openRate": 6.667,
      "solar": 169.7,
      "temperature": 13.8,
      "rh": 62.0,
      "vpd": 0.5996,
      "co2": 479
    },
    {
      "time": "07:35:20",
      "side": "east",
      "aperture": 2.2362,
      "poreArea": 20.0475,
      "aspectRatio": 0.17045,
      "openRate": 12.5,
      "solar": 169.7,
      "temperature": 13.8,
      "rh": 62.0,
      "vpd": 0.5996,
      "co2": 479
    },
    {
      "time": "07:35:26",
      "side": "east",
      "aperture": 3.0365,
      "poreArea": 37.4625,
      "aspectRatio": 0.18528,
      "openRate": 61.538,
      "solar": 169.7,
      "temperature": 13.8,
      "rh": 62.0,
      "vpd": 0.5996,
      "co2": 479
    },
    {
      "time": "07:35:35",
      "side": "east",
      "aperture": 3.0004,
      "poreArea": 30.5775,
      "aspectRatio": 0.21187,
      "openRate": 42.857,
      "solar": 173.9,
      "temperature": 13.9,
      "rh": 62.0,
      "vpd": 0.6035,
      "co2": 479
    },
    {
      "time": "07:35:50",
      "side": "east",
      "aperture": 2.5588,
      "poreArea": 29.2613,
      "aspectRatio": 0.16337,
      "openRate": 50.0,
      "solar": 173.9,
      "temperature": 13.9,
      "rh": 62.0,
      "vpd": 0.6035,
      "co2": 479
    },
    {
      "time": "07:36:11",
      "side": "east",
      "aperture": 2.2274,
      "poreArea": 17.1112,
      "aspectRatio": 0.21875,
      "openRate": 30.0,
      "solar": 173.9,
      "temperature": 13.9,
      "rh": 62.0,
      "vpd": 0.6035,
      "co2": 479
    },
    {
      "time": "07:36:58",
      "side": "east",
      "aperture": 2.5593,
      "poreArea": 27.3375,
      "aspectRatio": 0.16529,
      "openRate": 67.568,
      "solar": 178.1,
      "temperature": 14.0,
      "rh": 62.0,
      "vpd": 0.6075,
      "co2": 479
    },
    {
      "time": "07:39:34",
      "side": "east",
      "aperture": 2.2768,
      "poreArea": 22.275,
      "aspectRatio": 0.16312,
      "openRate": 38.889,
      "solar": 84.0,
      "temperature": 14.2,
      "rh": 62.0,
      "vpd": 0.6154,
      "co2": 479
    },
    {
      "time": "07:41:46",
      "side": "east",
      "aperture": 3.1678,
      "poreArea": 38.9813,
      "aspectRatio": 0.18926,
      "openRate": 8.333,
      "solar": 111.7,
      "temperature": 14.3,
      "rh": 62.0,
      "vpd": 0.6194,
      "co2": 479
    },
    {
      "time": "07:41:52",
      "side": "east",
      "aperture": 3.0318,
      "poreArea": 30.1725,
      "aspectRatio": 0.19147,
      "openRate": 73.077,
      "solar": 111.7,
      "temperature": 14.3,
      "rh": 62.0,
      "vpd": 0.6194,
      "co2": 479
    },
    {
      "time": "07:42:00",
      "side": "east",
      "aperture": 2.7407,
      "poreArea": 24.2494,
      "aspectRatio": 0.17592,
      "openRate": 12.245,
      "solar": 111.7,
      "temperature": 14.3,
      "rh": 62.0,
      "vpd": 0.6194,
      "co2": 479
    },
    {
      "time": "07:42:07",
      "side": "east",
      "aperture": 3.3941,
      "poreArea": 43.5881,
      "aspectRatio": 0.21562,
      "openRate": 17.391,
      "solar": 111.7,
      "temperature": 14.3,
      "rh": 62.0,
      "vpd": 0.6194,
      "co2": 479
    },
    {
      "time": "07:42:39",
      "side": "east",
      "aperture": 3.6475,
      "poreArea": 46.0688,
      "aspectRatio": 0.21773,
      "openRate": 17.647,
      "solar": 106.7,
      "temperature": 14.4,
      "rh": 62.0,
      "vpd": 0.6234,
      "co2": 463
    },
    {
      "time": "07:42:50",
      "side": "east",
      "aperture": 3.0119,
      "poreArea": 40.2975,
      "aspectRatio": 0.17143,
      "openRate": 11.111,
      "solar": 106.7,
      "temperature": 14.4,
      "rh": 62.0,
      "vpd": 0.6234,
      "co2": 463
    },
    {
      "time": "07:42:56",
      "side": "east",
      "aperture": 2.9366,
      "poreArea": 23.8444,
      "aspectRatio": 0.22715,
      "openRate": 24.0,
      "solar": 106.7,
      "temperature": 14.4,
      "rh": 62.0,
      "vpd": 0.6234,
      "co2": 463
    },
    {
      "time": "07:43:03",
      "side": "east",
      "aperture": 2.1768,
      "poreArea": 18.63,
      "aspectRatio": 0.16667,
      "openRate": 12.0,
      "solar": 106.7,
      "temperature": 14.4,
      "rh": 62.0,
      "vpd": 0.6234,
      "co2": 463
    },
    {
      "time": "07:43:07",
      "side": "east",
      "aperture": 2.4559,
      "poreArea": 27.54,
      "aspectRatio": 0.19765,
      "openRate": 31.25,
      "solar": 106.7,
      "temperature": 14.4,
      "rh": 62.0,
      "vpd": 0.6234,
      "co2": 463
    },
    {
      "time": "07:43:14",
      "side": "east",
      "aperture": 2.3325,
      "poreArea": 20.1994,
      "aspectRatio": 0.1764,
      "openRate": 50.0,
      "solar": 106.7,
      "temperature": 14.4,
      "rh": 62.0,
      "vpd": 0.6234,
      "co2": 463
    },
    {
      "time": "07:48:26",
      "side": "east",
      "aperture": 3.6575,
      "poreArea": 42.6769,
      "aspectRatio": 0.2126,
      "openRate": 89.474,
      "solar": 224.3,
      "temperature": 15.0,
      "rh": 61.0,
      "vpd": 0.6651,
      "co2": 463
    },
    {
      "time": "07:48:29",
      "side": "east",
      "aperture": 3.3536,
      "poreArea": 37.4625,
      "aspectRatio": 0.21965,
      "openRate": 74.194,
      "solar": 224.3,
      "temperature": 15.0,
      "rh": 61.0,
      "vpd": 0.6651,
      "co2": 463
    },
    {
      "time": "07:48:35",
      "side": "east",
      "aperture": 3.3206,
      "poreArea": 35.7413,
      "aspectRatio": 0.21429,
      "openRate": 81.081,
      "solar": 224.3,
      "temperature": 15.2,
      "rh": 62.0,
      "vpd": 0.6564,
      "co2": 463
    },
    {
      "time": "07:48:43",
      "side": "east",
      "aperture": 2.7068,
      "poreArea": 31.6913,
      "aspectRatio": 0.19243,
      "openRate": 71.429,
      "solar": 224.3,
      "temperature": 15.2,
      "rh": 62.0,
      "vpd": 0.6564,
      "co2": 463
    },
    {
      "time": "07:48:54",
      "side": "east",
      "aperture": 2.2163,
      "poreArea": 23.895,
      "aspectRatio": 0.18103,
      "openRate": 8.824,
      "solar": 224.3,
      "temperature": 15.2,
      "rh": 62.0,
      "vpd": 0.6564,
      "co2": 463
    },
    {
      "time": "07:49:01",
      "side": "east",
      "aperture": 2.6426,
      "poreArea": 30.0206,
      "aspectRatio": 0.15526,
      "openRate": 20.0,
      "solar": 224.3,
      "temperature": 15.2,
      "rh": 62.0,
      "vpd": 0.6564,
      "co2": 463
    },
    {
      "time": "07:49:07",
      "side": "east",
      "aperture": 2.6626,
      "poreArea": 30.4763,
      "aspectRatio": 0.16832,
      "openRate": 16.667,
      "solar": 224.3,
      "temperature": 15.2,
      "rh": 62.0,
      "vpd": 0.6564,
      "co2": 463
    },
    {
      "time": "07:49:52",
      "side": "east",
      "aperture": 3.3093,
      "poreArea": 28.5525,
      "aspectRatio": 0.2543,
      "openRate": 9.524,
      "solar": 226.0,
      "temperature": 15.3,
      "rh": 62.0,
      "vpd": 0.6607,
      "co2": 463
    },
    {
      "time": "07:52:40",
      "side": "east",
      "aperture": 2.5544,
      "poreArea": 26.4262,
      "aspectRatio": 0.16071,
      "openRate": 31.034,
      "solar": 234.4,
      "temperature": 15.7,
      "rh": 62.0,
      "vpd": 0.6778,
      "co2": 463
    },
    {
      "time": "07:52:49",
      "side": "east",
      "aperture": 2.4724,
      "poreArea": 25.11,
      "aspectRatio": 0.15967,
      "openRate": 20.69,
      "solar": 234.4,
      "temperature": 15.7,
      "rh": 62.0,
      "vpd": 0.6778,
      "co2": 463
    },
    {
      "time": "07:53:03",
      "side": "east",
      "aperture": 3.4654,
      "poreArea": 41.715,
      "aspectRatio": 0.20139,
      "openRate": 54.167,
      "solar": 234.4,
      "temperature": 15.7,
      "rh": 62.0,
      "vpd": 0.6778,
      "co2": 463
    },
    {
      "time": "07:53:11",
      "side": "east",
      "aperture": 2.6486,
      "poreArea": 28.8056,
      "aspectRatio": 0.18561,
      "openRate": 39.13,
      "solar": 234.4,
      "temperature": 15.7,
      "rh": 62.0,
      "vpd": 0.6778,
      "co2": 463
    },
    {
      "time": "07:53:20",
      "side": "east",
      "aperture": 2.8848,
      "poreArea": 35.8425,
      "aspectRatio": 0.16354,
      "openRate": 42.857,
      "solar": 234.4,
      "temperature": 15.7,
      "rh": 62.0,
      "vpd": 0.6778,
      "co2": 463
    },
    {
      "time": "07:53:27",
      "side": "east",
      "aperture": 2.5603,
      "poreArea": 20.6044,
      "aspectRatio": 0.20127,
      "openRate": 28.571,
      "solar": 234.4,
      "temperature": 15.7,
      "rh": 62.0,
      "vpd": 0.6778,
      "co2": 463
    },
    {
      "time": "07:53:52",
      "side": "east",
      "aperture": 3.71,
      "poreArea": 51.7388,
      "aspectRatio": 0.1899,
      "openRate": 7.895,
      "solar": 236.0,
      "temperature": 15.8,
      "rh": 61.0,
      "vpd": 0.7001,
      "co2": 463
    },
    {
      "time": "07:54:26",
      "side": "east",
      "aperture": 2.1332,
      "poreArea": 18.1744,
      "aspectRatio": 0.18069,
      "openRate": 8.696,
      "solar": 236.0,
      "temperature": 15.8,
      "rh": 61.0,
      "vpd": 0.7001,
      "co2": 463
    },
    {
      "time": "07:54:37",
      "side": "east",
      "aperture": 2.5408,
      "poreArea": 25.0088,
      "aspectRatio": 0.20339,
      "openRate": 38.889,
      "solar": 236.0,
      "temperature": 16.0,
      "rh": 62.0,
      "vpd": 0.6909,
      "co2": 463
    },
    {
      "time": "07:55:02",
      "side": "east",
      "aperture": 3.0083,
      "poreArea": 45.0562,
      "aspectRatio": 0.2069,
      "openRate": 31.25,
      "solar": 236.0,
      "temperature": 16.0,
      "rh": 62.0,
      "vpd": 0.6909,
      "co2": 463
    },
    {
      "time": "07:56:59",
      "side": "east",
      "aperture": 2.2319,
      "poreArea": 18.5794,
      "aspectRatio": 0.17612,
      "openRate": 12.5,
      "solar": 242.8,
      "temperature": 16.2,
      "rh": 61.0,
      "vpd": 0.7182,
      "co2": 447
    },
    {
      "time": "07:57:10",
      "side": "east",
      "aperture": 2.621,
      "poreArea": 23.9963,
      "aspectRatio": 0.2125,
      "openRate": 38.235,
      "solar": 242.8,
      "temperature": 16.2,
      "rh": 61.0,
      "vpd": 0.7182,
      "co2": 447
    },
    {
      "time": "07:57:19",
      "side": "east",
      "aperture": 2.4711,
      "poreArea": 15.4913,
      "aspectRatio": 0.25,
      "openRate": 1.961,
      "solar": 242.8,
      "temperature": 16.2,
      "rh": 61.0,
      "vpd": 0.7182,
      "co2": 447
    },
    {
      "time": "07:57:30",
      "side": "east",
      "aperture": 2.4753,
      "poreArea": 22.4269,
      "aspectRatio": 0.16566,
      "openRate": 25.0,
      "solar": 242.8,
      "temperature": 16.2,
      "rh": 61.0,
      "vpd": 0.7182,
      "co2": 447
    },
    {
      "time": "07:57:39",
      "side": "east",
      "aperture": 3.4212,
      "poreArea": 23.085,
      "aspectRatio": 0.35417,
      "openRate": 10.0,
      "solar": 211.7,
      "temperature": 16.2,
      "rh": 62.0,
      "vpd": 0.6998,
      "co2": 459
    },
    {
      "time": "07:57:47",
      "side": "east",
      "aperture": 2.2419,
      "poreArea": 18.3263,
      "aspectRatio": 0.2,
      "openRate": 3.571,
      "solar": 211.7,
      "temperature": 16.2,
      "rh": 62.0,
      "vpd": 0.6998,
      "co2": 459
    },
    {
      "time": "07:57:55",
      "side": "east",
      "aperture": 2.6917,
      "poreArea": 27.8944,
      "aspectRatio": 0.184,
      "openRate": 33.333,
      "solar": 211.7,
      "temperature": 16.2,
      "rh": 62.0,
      "vpd": 0.6998,
      "co2": 459
    },
    {
      "time": "07:58:16",
      "side": "east",
      "aperture": 2.3473,
      "poreArea": 26.4263,
      "aspectRatio": 0.16153,
      "openRate": 22.222,
      "solar": 211.7,
      "temperature": 16.2,
      "rh": 62.0,
      "vpd": 0.6998,
      "co2": 459
    },
    {
      "time": "07:58:33",
      "side": "east",
      "aperture": 2.1345,
      "poreArea": 16.8075,
      "aspectRatio": 0.18705,
      "openRate": 14.286,
      "solar": 251.2,
      "temperature": 16.3,
      "rh": 61.0,
      "vpd": 0.7228,
      "co2": 447
    },
    {
      "time": "07:58:41",
      "side": "east",
      "aperture": 2.8174,
      "poreArea": 30.8813,
      "aspectRatio": 0.20103,
      "openRate": 60.87,
      "solar": 251.2,
      "temperature": 16.3,
      "rh": 61.0,
      "vpd": 0.7228,
      "co2": 447
    },
    {
      "time": "08:04:59",
      "side": "east",
      "aperture": 2.6399,
      "poreArea": 28.35,
      "aspectRatio": 0.194,
      "openRate": 24.324,
      "solar": 274.7,
      "temperature": 17.0,
      "rh": 62.5,
      "vpd": 0.7266,
      "co2": 447
    },
    {
      "time": "08:05:22",
      "side": "east",
      "aperture": 2.9818,
      "poreArea": 26.325,
      "aspectRatio": 0.19892,
      "openRate": 83.333,
      "solar": 274.7,
      "temperature": 17.0,
      "rh": 62.5,
      "vpd": 0.7266,
      "co2": 447
    },
    {
      "time": "08:05:33",
      "side": "east",
      "aperture": 3.4713,
      "poreArea": 43.1325,
      "aspectRatio": 0.18719,
      "openRate": 75.0,
      "solar": 207.5,
      "temperature": 17.1,
      "rh": 62.5,
      "vpd": 0.7313,
      "co2": 447
    },
    {
      "time": "08:06:25",
      "side": "east",
      "aperture": 3.2262,
      "poreArea": 36.5512,
      "aspectRatio": 0.20174,
      "openRate": 70.833,
      "solar": 207.5,
      "temperature": 17.1,
      "rh": 62.5,
      "vpd": 0.7313,
      "co2": 447
    },
    {
      "time": "08:06:40",
      "side": "east",
      "aperture": 2.415,
      "poreArea": 20.9588,
      "aspectRatio": 0.19481,
      "openRate": 69.231,
      "solar": 203.3,
      "temperature": 17.2,
      "rh": 62.5,
      "vpd": 0.7359,
      "co2": 447
    },
    {
      "time": "08:06:48",
      "side": "east",
      "aperture": 2.4872,
      "poreArea": 20.4019,
      "aspectRatio": 0.20181,
      "openRate": 54.545,
      "solar": 203.3,
      "temperature": 17.2,
      "rh": 62.5,
      "vpd": 0.7359,
      "co2": 447
    },
    {
      "time": "08:06:58",
      "side": "east",
      "aperture": 2.7816,
      "poreArea": 29.8688,
      "aspectRatio": 0.18182,
      "openRate": 57.692,
      "solar": 203.3,
      "temperature": 17.2,
      "rh": 62.5,
      "vpd": 0.7359,
      "co2": 447
    },
    {
      "time": "08:07:08",
      "side": "east",
      "aperture": 2.25,
      "poreArea": 21.9713,
      "aspectRatio": 0.17391,
      "openRate": 21.875,
      "solar": 203.3,
      "temperature": 17.2,
      "rh": 62.5,
      "vpd": 0.7359,
      "co2": 447
    },
    {
      "time": "08:09:06",
      "side": "east",
      "aperture": 2.6623,
      "poreArea": 25.7681,
      "aspectRatio": 0.22256,
      "openRate": 80.0,
      "solar": 296.5,
      "temperature": 17.2,
      "rh": 63.0,
      "vpd": 0.7261,
      "co2": 431
    },
    {
      "time": "08:09:14",
      "side": "east",
      "aperture": 2.7771,
      "poreArea": 26.6288,
      "aspectRatio": 0.21547,
      "openRate": 77.778,
      "solar": 296.5,
      "temperature": 17.2,
      "rh": 63.0,
      "vpd": 0.7261,
      "co2": 431
    },
    {
      "time": "08:09:20",
      "side": "east",
      "aperture": 3.0661,
      "poreArea": 27.4387,
      "aspectRatio": 0.23231,
      "openRate": 90.909,
      "solar": 296.5,
      "temperature": 17.2,
      "rh": 63.0,
      "vpd": 0.7261,
      "co2": 431
    },
    {
      "time": "08:09:30",
      "side": "east",
      "aperture": 3.15,
      "poreArea": 28.2488,
      "aspectRatio": 0.24138,
      "openRate": 87.879,
      "solar": 296.5,
      "temperature": 17.2,
      "rh": 63.0,
      "vpd": 0.7261,
      "co2": 431
    },
    {
      "time": "08:09:38",
      "side": "east",
      "aperture": 2.9855,
      "poreArea": 33.8175,
      "aspectRatio": 0.21429,
      "openRate": 69.231,
      "solar": 297.4,
      "temperature": 17.2,
      "rh": 64.0,
      "vpd": 0.7065,
      "co2": 431
    },
    {
      "time": "08:09:54",
      "side": "east",
      "aperture": 2.8638,
      "poreArea": 23.9963,
      "aspectRatio": 0.24324,
      "openRate": 9.091,
      "solar": 297.4,
      "temperature": 17.2,
      "rh": 64.0,
      "vpd": 0.7065,
      "co2": 431
    },
    {
      "time": "08:10:10",
      "side": "east",
      "aperture": 2.415,
      "poreArea": 24.0975,
      "aspectRatio": 0.17143,
      "openRate": 10.0,
      "solar": 297.4,
      "temperature": 17.2,
      "rh": 64.0,
      "vpd": 0.7065,
      "co2": 431
    },
    {
      "time": "08:10:21",
      "side": "east",
      "aperture": 2.8677,
      "poreArea": 25.6163,
      "aspectRatio": 0.1875,
      "openRate": 4.839,
      "solar": 297.4,
      "temperature": 17.2,
      "rh": 64.0,
      "vpd": 0.7065,
      "co2": 431
    },
    {
      "time": "08:10:34",
      "side": "east",
      "aperture": 2.4559,
      "poreArea": 23.5913,
      "aspectRatio": 0.18033,
      "openRate": 2.222,
      "solar": 311.6,
      "temperature": 17.2,
      "rh": 64.0,
      "vpd": 0.7065,
      "co2": 431
    },
    {
      "time": "08:10:41",
      "side": "east",
      "aperture": 2.5767,
      "poreArea": 29.16,
      "aspectRatio": 0.18491,
      "openRate": 10.204,
      "solar": 311.6,
      "temperature": 17.2,
      "rh": 64.0,
      "vpd": 0.7065,
      "co2": 431
    },
    {
      "time": "08:14:34",
      "side": "east",
      "aperture": 2.7,
      "poreArea": 25.8188,
      "aspectRatio": 0.22222,
      "openRate": 75.0,
      "solar": 332.6,
      "temperature": 17.5,
      "rh": 64.0,
      "vpd": 0.72,
      "co2": 431
    },
    {
      "time": "08:14:50",
      "side": "east",
      "aperture": 4.4553,
      "poreArea": 49.41,
      "aspectRatio": 0.27448,
      "openRate": 33.333,
      "solar": 332.6,
      "temperature": 17.5,
      "rh": 64.0,
      "vpd": 0.72,
      "co2": 431
    },
    {
      "time": "08:15:02",
      "side": "east",
      "aperture": 3.273,
      "poreArea": 33.9188,
      "aspectRatio": 0.20434,
      "openRate": 78.947,
      "solar": 332.6,
      "temperature": 17.5,
      "rh": 64.0,
      "vpd": 0.72,
      "co2": 431
    },
    {
      "time": "08:15:45",
      "side": "east",
      "aperture": 2.7669,
      "poreArea": 26.73,
      "aspectRatio": 0.20586,
      "openRate": 24.49,
      "solar": 335.2,
      "temperature": 17.6,
      "rh": 64.0,
      "vpd": 0.7246,
      "co2": 431
    },
    {
      "time": "08:16:12",
      "side": "east",
      "aperture": 2.6413,
      "poreArea": 27.6412,
      "aspectRatio": 0.18468,
      "openRate": 18.182,
      "solar": 335.2,
      "temperature": 17.6,
      "rh": 64.0,
      "vpd": 0.7246,
      "co2": 431
    },
    {
      "time": "08:16:32",
      "side": "east",
      "aperture": 2.6969,
      "poreArea": 20.8575,
      "aspectRatio": 0.21429,
      "openRate": 10.0,
      "solar": 342.7,
      "temperature": 17.7,
      "rh": 64.0,
      "vpd": 0.7291,
      "co2": 431
    },
    {
      "time": "08:16:57",
      "side": "east",
      "aperture": 2.2498,
      "poreArea": 22.7812,
      "aspectRatio": 0.15157,
      "openRate": 5.556,
      "solar": 342.7,
      "temperature": 17.7,
      "rh": 64.0,
      "vpd": 0.7291,
      "co2": 431
    },
    {
      "time": "08:17:36",
      "side": "east",
      "aperture": 2.4559,
      "poreArea": 20.7563,
      "aspectRatio": 0.2,
      "openRate": 69.231,
      "solar": 343.6,
      "temperature": 17.8,
      "rh": 65.0,
      "vpd": 0.7134,
      "co2": 415
    },
    {
      "time": "08:19:56",
      "side": "east",
      "aperture": 3.3678,
      "poreArea": 44.0438,
      "aspectRatio": 0.18904,
      "openRate": 58.333,
      "solar": 352.0,
      "temperature": 18.1,
      "rh": 66.0,
      "vpd": 0.7062,
      "co2": 415
    },
    {
      "time": "08:20:10",
      "side": "east",
      "aperture": 3.0051,
      "poreArea": 38.1206,
      "aspectRatio": 0.1853,
      "openRate": 50.0,
      "solar": 352.0,
      "temperature": 18.1,
      "rh": 66.0,
      "vpd": 0.7062,
      "co2": 415
    },
    {
      "time": "08:20:43",
      "side": "east",
      "aperture": 2.8406,
      "poreArea": 28.9069,
      "aspectRatio": 0.22614,
      "openRate": 76.471,
      "solar": 359.5,
      "temperature": 18.3,
      "rh": 66.0,
      "vpd": 0.7151,
      "co2": 415
    },
    {
      "time": "08:20:55",
      "side": "east",
      "aperture": 2.25,
      "poreArea": 18.3263,
      "aspectRatio": 0.20833,
      "openRate": 11.111,
      "solar": 359.5,
      "temperature": 18.3,
      "rh": 66.0,
      "vpd": 0.7151,
      "co2": 415
    },
    {
      "time": "08:21:14",
      "side": "east",
      "aperture": 2.5366,
      "poreArea": 21.0094,
      "aspectRatio": 0.21232,
      "openRate": 39.316,
      "solar": 359.5,
      "temperature": 18.3,
      "rh": 66.0,
      "vpd": 0.7151,
      "co2": 415
    },
    {
      "time": "08:21:37",
      "side": "east",
      "aperture": 2.5675,
      "poreArea": 20.5538,
      "aspectRatio": 0.23596,
      "openRate": 40.541,
      "solar": 360.4,
      "temperature": 18.5,
      "rh": 66.0,
      "vpd": 0.7241,
      "co2": 415
    },
    {
      "time": "08:21:52",
      "side": "east",
      "aperture": 2.0298,
      "poreArea": 10.125,
      "aspectRatio": 0.27381,
      "openRate": 3.571,
      "solar": 360.4,
      "temperature": 18.5,
      "rh": 66.0,
      "vpd": 0.7241,
      "co2": 415
    },
    {
      "time": "08:22:14",
      "side": "east",
      "aperture": 2.6125,
      "poreArea": 25.8694,
      "aspectRatio": 0.18723,
      "openRate": 36.364,
      "solar": 360.4,
      "temperature": 18.5,
      "rh": 66.0,
      "vpd": 0.7241,
      "co2": 415
    },
    {
      "time": "08:22:33",
      "side": "east",
      "aperture": 2.498,
      "poreArea": 22.7306,
      "aspectRatio": 0.20252,
      "openRate": 53.333,
      "solar": 357.8,
      "temperature": 18.6,
      "rh": 66.0,
      "vpd": 0.7287,
      "co2": 415
    },
    {
      "time": "08:22:47",
      "side": "east",
      "aperture": 2.5744,
      "poreArea": 23.0344,
      "aspectRatio": 0.21167,
      "openRate": 63.636,
      "solar": 357.8,
      "temperature": 18.6,
      "rh": 66.0,
      "vpd": 0.7287,
      "co2": 415
    },
    {
      "time": "08:25:31",
      "side": "east",
      "aperture": 2.6194,
      "poreArea": 25.515,
      "aspectRatio": 0.20779,
      "openRate": 84.0,
      "solar": 378.0,
      "temperature": 19.1,
      "rh": 66.0,
      "vpd": 0.7518,
      "co2": 399
    },
    {
      "time": "08:25:46",
      "side": "east",
      "aperture": 3.314,
      "poreArea": 35.2856,
      "aspectRatio": 0.23646,
      "openRate": 76.923,
      "solar": 378.0,
      "temperature": 19.1,
      "rh": 66.0,
      "vpd": 0.7518,
      "co2": 399
    },
    {
      "time": "08:26:05",
      "side": "east",
      "aperture": 2.7626,
      "poreArea": 28.755,
      "aspectRatio": 0.19871,
      "openRate": 43.478,
      "solar": 378.0,
      "temperature": 19.1,
      "rh": 66.0,
      "vpd": 0.7518,
      "co2": 399
    },
    {
      "time": "08:26:23",
      "side": "east",
      "aperture": 2.8419,
      "poreArea": 28.1475,
      "aspectRatio": 0.19633,
      "openRate": 94.737,
      "solar": 378.0,
      "temperature": 19.1,
      "rh": 66.0,
      "vpd": 0.7518,
      "co2": 399
    },
    {
      "time": "08:26:53",
      "side": "east",
      "aperture": 2.4191,
      "poreArea": 18.0225,
      "aspectRatio": 0.21762,
      "openRate": 42.857,
      "solar": 382.2,
      "temperature": 19.2,
      "rh": 66.0,
      "vpd": 0.7565,
      "co2": 399
    },
    {
      "time": "08:27:06",
      "side": "east",
      "aperture": 2.8954,
      "poreArea": 30.2738,
      "aspectRatio": 0.2,
      "openRate": 45.763,
      "solar": 382.2,
      "temperature": 19.2,
      "rh": 66.0,
      "vpd": 0.7565,
      "co2": 399
    },
    {
      "time": "08:27:14",
      "side": "east",
      "aperture": 2.9003,
      "poreArea": 29.4638,
      "aspectRatio": 0.18877,
      "openRate": 21.053,
      "solar": 382.2,
      "temperature": 19.2,
      "rh": 66.0,
      "vpd": 0.7565,
      "co2": 399
    },
    {
      "time": "08:27:26",
      "side": "east",
      "aperture": 2.5654,
      "poreArea": 25.4138,
      "aspectRatio": 0.20776,
      "openRate": 46.667,
      "solar": 382.2,
      "temperature": 19.2,
      "rh": 66.0,
      "vpd": 0.7565,
      "co2": 399
    },
    {
      "time": "08:27:35",
      "side": "east",
      "aperture": 3.182,
      "poreArea": 35.8425,
      "aspectRatio": 0.21583,
      "openRate": 80.952,
      "solar": 386.4,
      "temperature": 19.4,
      "rh": 67.0,
      "vpd": 0.7434,
      "co2": 399
    },
    {
      "time": "08:30:07",
      "side": "east",
      "aperture": 2.6605,
      "poreArea": 26.8819,
      "aspectRatio": 0.21847,
      "openRate": 63.636,
      "solar": 399.8,
      "temperature": 19.8,
      "rh": 67.0,
      "vpd": 0.7621,
      "co2": 399
    },
    {
      "time": "08:30:25",
      "side": "east",
      "aperture": 2.8434,
      "poreArea": 27.0338,
      "aspectRatio": 0.19856,
      "openRate": 86.0,
      "solar": 399.8,
      "temperature": 19.8,
      "rh": 67.0,
      "vpd": 0.7621,
      "co2": 399
    },
    {
      "time": "08:30:35",
      "side": "east",
      "aperture": 3.0415,
      "poreArea": 28.0969,
      "aspectRatio": 0.23025,
      "openRate": 84.507,
      "solar": 409.9,
      "temperature": 20.0,
      "rh": 67.0,
      "vpd": 0.7716,
      "co2": 399
    },
    {
      "time": "08:30:56",
      "side": "east",
      "aperture": 2.7093,
      "poreArea": 29.2613,
      "aspectRatio": 0.19469,
      "openRate": 65.517,
      "solar": 409.9,
      "temperature": 20.0,
      "rh": 67.0,
      "vpd": 0.7716,
      "co2": 399
    },
    {
      "time": "08:31:04",
      "side": "east",
      "aperture": 3.2966,
      "poreArea": 33.9694,
      "aspectRatio": 0.2598,
      "openRate": 76.923,
      "solar": 409.9,
      "temperature": 20.0,
      "rh": 67.0,
      "vpd": 0.7716,
      "co2": 399
    },
    {
      "time": "08:31:11",
      "side": "east",
      "aperture": 2.7547,
      "poreArea": 24.6544,
      "aspectRatio": 0.24554,
      "openRate": 100.0,
      "solar": 409.9,
      "temperature": 20.0,
      "rh": 67.0,
      "vpd": 0.7716,
      "co2": 399
    },
    {
      "time": "08:31:23",
      "side": "east",
      "aperture": 3.0063,
      "poreArea": 31.8938,
      "aspectRatio": 0.19626,
      "openRate": 78.846,
      "solar": 409.9,
      "temperature": 20.0,
      "rh": 67.0,
      "vpd": 0.7716,
      "co2": 399
    },
    {
      "time": "08:31:30",
      "side": "east",
      "aperture": 2.8852,
      "poreArea": 31.4888,
      "aspectRatio": 0.18638,
      "openRate": 79.167,
      "solar": 409.9,
      "temperature": 20.0,
      "rh": 67.0,
      "vpd": 0.7716,
      "co2": 399
    },
    {
      "time": "08:31:38",
      "side": "east",
      "aperture": 2.7176,
      "poreArea": 26.6794,
      "aspectRatio": 0.21673,
      "openRate": 60.0,
      "solar": 416.6,
      "temperature": 20.2,
      "rh": 68.0,
      "vpd": 0.7576,
      "co2": 399
    },
    {
      "time": "08:31:46",
      "side": "east",
      "aperture": 2.7458,
      "poreArea": 28.1475,
      "aspectRatio": 0.1875,
      "openRate": 70.0,
      "solar": 416.6,
      "temperature": 20.2,
      "rh": 68.0,
      "vpd": 0.7576,
      "co2": 399
    },
    {
      "time": "08:35:25",
      "side": "east",
      "aperture": 2.8775,
      "poreArea": 31.6913,
      "aspectRatio": 0.19674,
      "openRate": 61.364,
      "solar": 439.3,
      "temperature": 20.7,
      "rh": 68.0,
      "vpd": 0.7813,
      "co2": 387
    },
    {
      "time": "08:35:33",
      "side": "east",
      "aperture": 2.6917,
      "poreArea": 31.6406,
      "aspectRatio": 0.18735,
      "openRate": 29.268,
      "solar": 441.8,
      "temperature": 20.9,
      "rh": 68.0,
      "vpd": 0.791,
      "co2": 387
    },
    {
      "time": "08:36:13",
      "side": "east",
      "aperture": 3.1691,
      "poreArea": 32.0456,
      "aspectRatio": 0.22002,
      "openRate": 92.308,
      "solar": 441.8,
      "temperature": 20.9,
      "rh": 68.0,
      "vpd": 0.791,
      "co2": 387
    },
    {
      "time": "08:36:24",
      "side": "east",
      "aperture": 2.6162,
      "poreArea": 24.5025,
      "aspectRatio": 0.21053,
      "openRate": 40.426,
      "solar": 441.8,
      "temperature": 20.9,
      "rh": 68.0,
      "vpd": 0.791,
      "co2": 387
    },
    {
      "time": "08:36:34",
      "side": "east",
      "aperture": 2.7285,
      "poreArea": 27.0338,
      "aspectRatio": 0.19926,
      "openRate": 53.448,
      "solar": 443.5,
      "temperature": 21.1,
      "rh": 68.0,
      "vpd": 0.8007,
      "co2": 387
    },
    {
      "time": "08:36:54",
      "side": "east",
      "aperture": 3.0755,
      "poreArea": 29.8688,
      "aspectRatio": 0.23077,
      "openRate": 91.667,
      "solar": 443.5,
      "temperature": 21.1,
      "rh": 68.0,
      "vpd": 0.8007,
      "co2": 387
    },
    {
      "time": "08:37:03",
      "side": "east",
      "aperture": 2.7,
      "poreArea": 23.2875,
      "aspectRatio": 0.2151,
      "openRate": 57.895,
      "solar": 443.5,
      "temperature": 21.1,
      "rh": 68.0,
      "vpd": 0.8007,
      "co2": 387
    },
    {
      "time": "08:37:14",
      "side": "east",
      "aperture": 2.7372,
      "poreArea": 22.5788,
      "aspectRatio": 0.21643,
      "openRate": 44.681,
      "solar": 443.5,
      "temperature": 21.1,
      "rh": 68.0,
      "vpd": 0.8007,
      "co2": 387
    },
    {
      "time": "08:37:28",
      "side": "east",
      "aperture": 2.5456,
      "poreArea": 20.3513,
      "aspectRatio": 0.22798,
      "openRate": 32.143,
      "solar": 443.5,
      "temperature": 21.1,
      "rh": 68.0,
      "vpd": 0.8007,
      "co2": 387
    },
    {
      "time": "08:37:43",
      "side": "east",
      "aperture": 2.5908,
      "poreArea": 21.2625,
      "aspectRatio": 0.21345,
      "openRate": 81.69,
      "solar": 443.5,
      "temperature": 21.2,
      "rh": 68.0,
      "vpd": 0.8057,
      "co2": 387
    },
    {
      "time": "08:41:17",
      "side": "east",
      "aperture": 2.4696,
      "poreArea": 20.655,
      "aspectRatio": 0.21477,
      "openRate": 25.0,
      "solar": 445.2,
      "temperature": 21.6,
      "rh": 69.0,
      "vpd": 0.7998,
      "co2": 387
    },
    {
      "time": "08:41:25",
      "side": "east",
      "aperture": 2.8965,
      "poreArea": 23.9456,
      "aspectRatio": 0.23702,
      "openRate": 100.0,
      "solar": 445.2,
      "temperature": 21.6,
      "rh": 69.0,
      "vpd": 0.7998,
      "co2": 387
    },
    {
      "time": "08:41:36",
      "side": "east",
      "aperture": 2.8001,
      "poreArea": 26.9325,
      "aspectRatio": 0.21739,
      "openRate": 97.059,
      "solar": 441.8,
      "temperature": 21.7,
      "rh": 68.0,
      "vpd": 0.8307,
      "co2": 387
    },
    {
      "time": "08:41:45",
      "side": "east",
      "aperture": 2.9426,
      "poreArea": 28.2488,
      "aspectRatio": 0.2138,
      "openRate": 94.444,
      "solar": 441.8,
      "temperature": 21.7,
      "rh": 68.0,
      "vpd": 0.8307,
      "co2": 387
    },
    {
      "time": "08:41:58",
      "side": "east",
      "aperture": 3.0699,
      "poreArea": 27.945,
      "aspectRatio": 0.23529,
      "openRate": 86.364,
      "solar": 441.8,
      "temperature": 21.7,
      "rh": 68.0,
      "vpd": 0.8307,
      "co2": 387
    },
    {
      "time": "08:42:01",
      "side": "east",
      "aperture": 2.7915,
      "poreArea": 26.2238,
      "aspectRatio": 0.19792,
      "openRate": 65.217,
      "solar": 441.8,
      "temperature": 21.7,
      "rh": 68.0,
      "vpd": 0.8307,
      "co2": 387
    },
    {
      "time": "08:42:10",
      "side": "east",
      "aperture": 3.2249,
      "poreArea": 35.8425,
      "aspectRatio": 0.23333,
      "openRate": 90.0,
      "solar": 441.8,
      "temperature": 21.7,
      "rh": 68.0,
      "vpd": 0.8307,
      "co2": 387
    },
    {
      "time": "08:42:19",
      "side": "east",
      "aperture": 2.8174,
      "poreArea": 28.1475,
      "aspectRatio": 0.22581,
      "openRate": 72.222,
      "solar": 441.8,
      "temperature": 21.7,
      "rh": 68.0,
      "vpd": 0.8307,
      "co2": 387
    },
    {
      "time": "08:42:37",
      "side": "east",
      "aperture": 2.8572,
      "poreArea": 29.5144,
      "aspectRatio": 0.19677,
      "openRate": 90.0,
      "solar": 449.4,
      "temperature": 21.8,
      "rh": 69.0,
      "vpd": 0.8097,
      "co2": 387
    },
    {
      "time": "08:42:59",
      "side": "east",
      "aperture": 2.7241,
      "poreArea": 23.1863,
      "aspectRatio": 0.24966,
      "openRate": 22.727,
      "solar": 449.4,
      "temperature": 21.8,
      "rh": 69.0,
      "vpd": 0.8097,
      "co2": 387
    },
    {
      "time": "08:59:05",
      "side": "east",
      "aperture": 3.4477,
      "poreArea": 38.07,
      "aspectRatio": 0.22462,
      "openRate": 98.0,
      "solar": 493.9,
      "temperature": 22.0,
      "rh": 68.0,
      "vpd": 0.8461,
      "co2": 347
    },
    {
      "time": "08:59:11",
      "side": "east",
      "aperture": 3.1032,
      "poreArea": 34.5263,
      "aspectRatio": 0.21318,
      "openRate": 94.737,
      "solar": 493.9,
      "temperature": 22.0,
      "rh": 68.0,
      "vpd": 0.8461,
      "co2": 347
    },
    {
      "time": "08:59:21",
      "side": "east",
      "aperture": 3.15,
      "poreArea": 37.7662,
      "aspectRatio": 0.21233,
      "openRate": 95.833,
      "solar": 493.9,
      "temperature": 22.0,
      "rh": 68.0,
      "vpd": 0.8461,
      "co2": 347
    },
    {
      "time": "08:59:42",
      "side": "east",
      "aperture": 2.5306,
      "poreArea": 23.7938,
      "aspectRatio": 0.16381,
      "openRate": 44.444,
      "solar": 484.7,
      "temperature": 22.0,
      "rh": 67.0,
      "vpd": 0.8725,
      "co2": 347
    },
    {
      "time": "09:00:05",
      "side": "east",
      "aperture": 2.7476,
      "poreArea": 25.2619,
      "aspectRatio": 0.22034,
      "openRate": 71.429,
      "solar": 484.7,
      "temperature": 22.0,
      "rh": 67.0,
      "vpd": 0.8725,
      "co2": 347
    },
    {
      "time": "09:00:16",
      "side": "east",
      "aperture": 2.5504,
      "poreArea": 26.0719,
      "aspectRatio": 0.19885,
      "openRate": 86.667,
      "solar": 484.7,
      "temperature": 22.0,
      "rh": 67.0,
      "vpd": 0.8725,
      "co2": 347
    },
    {
      "time": "09:00:27",
      "side": "east",
      "aperture": 2.4171,
      "poreArea": 19.0856,
      "aspectRatio": 0.21253,
      "openRate": 50.0,
      "solar": 484.7,
      "temperature": 22.0,
      "rh": 67.0,
      "vpd": 0.8725,
      "co2": 347
    },
    {
      "time": "09:00:42",
      "side": "east",
      "aperture": 2.7912,
      "poreArea": 28.4513,
      "aspectRatio": 0.23565,
      "openRate": 100.0,
      "solar": 460.3,
      "temperature": 22.1,
      "rh": 68.0,
      "vpd": 0.8512,
      "co2": 347
    },
    {
      "time": "09:04:39",
      "side": "east",
      "aperture": 2.8276,
      "poreArea": 26.9325,
      "aspectRatio": 0.20844,
      "openRate": 83.871,
      "solar": 530.9,
      "temperature": 22.6,
      "rh": 71.0,
      "vpd": 0.7952,
      "co2": 363
    },
    {
      "time": "09:04:56",
      "side": "east",
      "aperture": 3.5925,
      "poreArea": 39.5888,
      "aspectRatio": 0.20533,
      "openRate": 82.353,
      "solar": 530.9,
      "temperature": 22.6,
      "rh": 71.0,
      "vpd": 0.7952,
      "co2": 363
    },
    {
      "time": "09:05:15",
      "side": "east",
      "aperture": 3.0867,
      "poreArea": 33.9188,
      "aspectRatio": 0.21048,
      "openRate": 90.909,
      "solar": 530.9,
      "temperature": 22.6,
      "rh": 71.0,
      "vpd": 0.7952,
      "co2": 363
    },
    {
      "time": "09:05:27",
      "side": "east",
      "aperture": 3.495,
      "poreArea": 45.8156,
      "aspectRatio": 0.20239,
      "openRate": 91.667,
      "solar": 530.9,
      "temperature": 22.6,
      "rh": 71.0,
      "vpd": 0.7952,
      "co2": 363
    },
    {
      "time": "09:05:42",
      "side": "east",
      "aperture": 3.0831,
      "poreArea": 34.6275,
      "aspectRatio": 0.18189,
      "openRate": 83.333,
      "solar": 420.8,
      "temperature": 22.8,
      "rh": 71.0,
      "vpd": 0.8049,
      "co2": 363
    },
    {
      "time": "09:05:52",
      "side": "east",
      "aperture": 2.9384,
      "poreArea": 31.3875,
      "aspectRatio": 0.20621,
      "openRate": 85.714,
      "solar": 420.8,
      "temperature": 22.8,
      "rh": 71.0,
      "vpd": 0.8049,
      "co2": 363
    },
    {
      "time": "09:06:04",
      "side": "east",
      "aperture": 2.8327,
      "poreArea": 34.2225,
      "aspectRatio": 0.18867,
      "openRate": 70.968,
      "solar": 420.8,
      "temperature": 22.8,
      "rh": 71.0,
      "vpd": 0.8049,
      "co2": 363
    },
    {
      "time": "09:06:12",
      "side": "east",
      "aperture": 3.1307,
      "poreArea": 39.8925,
      "aspectRatio": 0.20122,
      "openRate": 100.0,
      "solar": 420.8,
      "temperature": 22.8,
      "rh": 71.0,
      "vpd": 0.8049,
      "co2": 363
    },
    {
      "time": "09:06:31",
      "side": "east",
      "aperture": 3.24,
      "poreArea": 34.1213,
      "aspectRatio": 0.22374,
      "openRate": 91.026,
      "solar": 533.4,
      "temperature": 23.1,
      "rh": 72.0,
      "vpd": 0.7914,
      "co2": 363
    },
    {
      "time": "09:06:42",
      "side": "east",
      "aperture": 3.5682,
      "poreArea": 35.9438,
      "aspectRatio": 0.22128,
      "openRate": 100.0,
      "solar": 533.4,
      "temperature": 23.1,
      "rh": 72.0,
      "vpd": 0.7914,
      "co2": 363
    },
    {
      "time": "09:10:19",
      "side": "east",
      "aperture": 3.8603,
      "poreArea": 40.6013,
      "aspectRatio": 0.2449,
      "openRate": 100.0,
      "solar": 522.5,
      "temperature": 23.7,
      "rh": 71.0,
      "vpd": 0.8499,
      "co2": 375
    },
    {
      "time": "09:10:32",
      "side": "east",
      "aperture": 4.32,
      "poreArea": 52.5488,
      "aspectRatio": 0.27586,
      "openRate": 100.0,
      "solar": 499.8,
      "temperature": 24.0,
      "rh": 70.0,
      "vpd": 0.8952,
      "co2": 391
    },
    {
      "time": "09:10:44",
      "side": "east",
      "aperture": 4.773,
      "poreArea": 57.7125,
      "aspectRatio": 0.27273,
      "openRate": 98.077,
      "solar": 499.8,
      "temperature": 24.0,
      "rh": 70.0,
      "vpd": 0.8952,
      "co2": 391
    },
    {
      "time": "09:12:35",
      "side": "east",
      "aperture": 4.5,
      "poreArea": 39.8925,
      "aspectRatio": 0.36735,
      "openRate": 95.833,
      "solar": 484.7,
      "temperature": 24.5,
      "rh": 70.0,
      "vpd": 0.9224,
      "co2": 391
    },
    {
      "time": "09:15:12",
      "side": "east",
      "aperture": 2.3673,
      "poreArea": 17.415,
      "aspectRatio": 0.25,
      "openRate": 62.162,
      "solar": 501.5,
      "temperature": 25.0,
      "rh": 70.0,
      "vpd": 0.9503,
      "co2": 403
    },
    {
      "time": "09:16:35",
      "side": "east",
      "aperture": 4.773,
      "poreArea": 56.0925,
      "aspectRatio": 0.29213,
      "openRate": 95.556,
      "solar": 453.6,
      "temperature": 25.4,
      "rh": 70.0,
      "vpd": 0.9732,
      "co2": 415
    },
    {
      "time": "09:16:41",
      "side": "east",
      "aperture": 4.6748,
      "poreArea": 52.9031,
      "aspectRatio": 0.31255,
      "openRate": 97.674,
      "solar": 453.6,
      "temperature": 25.4,
      "rh": 70.0,
      "vpd": 0.9732,
      "co2": 415
    },
    {
      "time": "09:16:49",
      "side": "east",
      "aperture": 5.1174,
      "poreArea": 56.1938,
      "aspectRatio": 0.32119,
      "openRate": 95.522,
      "solar": 453.6,
      "temperature": 25.4,
      "rh": 70.0,
      "vpd": 0.9732,
      "co2": 415
    },
    {
      "time": "09:24:52",
      "side": "east",
      "aperture": 4.01,
      "poreArea": 43.5881,
      "aspectRatio": 0.26799,
      "openRate": 93.75,
      "solar": 268.0,
      "temperature": 25.4,
      "rh": 68.0,
      "vpd": 1.0381,
      "co2": 463
    },
    {
      "time": "09:25:10",
      "side": "east",
      "aperture": 4.287,
      "poreArea": 49.1063,
      "aspectRatio": 0.26596,
      "openRate": 100.0,
      "solar": 268.0,
      "temperature": 25.4,
      "rh": 68.0,
      "vpd": 1.0381,
      "co2": 463
    },
    {
      "time": "09:25:16",
      "side": "east",
      "aperture": 3.8881,
      "poreArea": 43.3856,
      "aspectRatio": 0.25808,
      "openRate": 96.552,
      "solar": 268.0,
      "temperature": 25.4,
      "rh": 68.0,
      "vpd": 1.0381,
      "co2": 463
    },
    {
      "time": "09:25:28",
      "side": "east",
      "aperture": 3.9544,
      "poreArea": 39.9937,
      "aspectRatio": 0.24967,
      "openRate": 94.118,
      "solar": 268.0,
      "temperature": 25.4,
      "rh": 68.0,
      "vpd": 1.0381,
      "co2": 463
    },
    {
      "time": "09:25:39",
      "side": "east",
      "aperture": 4.05,
      "poreArea": 46.17,
      "aspectRatio": 0.26129,
      "openRate": 98.0,
      "solar": 257.9,
      "temperature": 25.3,
      "rh": 68.0,
      "vpd": 1.0319,
      "co2": 463
    },
    {
      "time": "09:25:52",
      "side": "east",
      "aperture": 3.8184,
      "poreArea": 40.6013,
      "aspectRatio": 0.26105,
      "openRate": 93.75,
      "solar": 257.9,
      "temperature": 25.3,
      "rh": 68.0,
      "vpd": 1.0319,
      "co2": 463
    },
    {
      "time": "09:31:50",
      "side": "east",
      "aperture": 2.6579,
      "poreArea": 30.2738,
      "aspectRatio": 0.18193,
      "openRate": 36.667,
      "solar": 360.4,
      "temperature": 25.4,
      "rh": 65.0,
      "vpd": 1.1354,
      "co2": 475
    },
    {
      "time": "09:32:12",
      "side": "east",
      "aperture": 3.9274,
      "poreArea": 44.6513,
      "aspectRatio": 0.25581,
      "openRate": 96.429,
      "solar": 360.4,
      "temperature": 25.4,
      "rh": 65.0,
      "vpd": 1.1354,
      "co2": 475
    },
    {
      "time": "09:32:19",
      "side": "east",
      "aperture": 3.5448,
      "poreArea": 36.2475,
      "aspectRatio": 0.29333,
      "openRate": 11.765,
      "solar": 360.4,
      "temperature": 25.4,
      "rh": 65.0,
      "vpd": 1.1354,
      "co2": 475
    },
    {
      "time": "09:32:29",
      "side": "east",
      "aperture": 4.0578,
      "poreArea": 46.17,
      "aspectRatio": 0.26145,
      "openRate": 33.333,
      "solar": 360.4,
      "temperature": 25.4,
      "rh": 65.0,
      "vpd": 1.1354,
      "co2": 475
    },
    {
      "time": "09:52:29",
      "side": "east",
      "aperture": 4.7641,
      "poreArea": 49.5113,
      "aspectRatio": 0.34059,
      "openRate": 100.0,
      "solar": 318.4,
      "temperature": 25.5,
      "rh": 62.0,
      "vpd": 1.2401,
      "co2": 451
    },
    {
      "time": "09:52:34",
      "side": "east",
      "aperture": 4.4548,
      "poreArea": 50.625,
      "aspectRatio": 0.29,
      "openRate": 100.0,
      "solar": 367.9,
      "temperature": 25.4,
      "rh": 62.0,
      "vpd": 1.2327,
      "co2": 435
    },
    {
      "time": "09:52:41",
      "side": "east",
      "aperture": 3.2204,
      "poreArea": 34.425,
      "aspectRatio": 0.25851,
      "openRate": 88.889,
      "solar": 367.9,
      "temperature": 25.4,
      "rh": 62.0,
      "vpd": 1.2327,
      "co2": 435
    },
    {
      "time": "09:52:54",
      "side": "east",
      "aperture": 5.0455,
      "poreArea": 51.8906,
      "aspectRatio": 0.36578,
      "openRate": 96.0,
      "solar": 367.9,
      "temperature": 25.4,
      "rh": 62.0,
      "vpd": 1.2327,
      "co2": 435
    },
    {
      "time": "09:53:02",
      "side": "east",
      "aperture": 2.8308,
      "poreArea": 29.565,
      "aspectRatio": 0.21035,
      "openRate": 33.333,
      "solar": 367.9,
      "temperature": 25.4,
      "rh": 62.0,
      "vpd": 1.2327,
      "co2": 435
    },
    {
      "time": "09:53:20",
      "side": "east",
      "aperture": 2.5448,
      "poreArea": 22.4269,
      "aspectRatio": 0.19593,
      "openRate": 58.537,
      "solar": 367.9,
      "temperature": 25.4,
      "rh": 62.0,
      "vpd": 1.2327,
      "co2": 435
    },
    {
      "time": "09:53:38",
      "side": "east",
      "aperture": 2.4761,
      "poreArea": 21.3637,
      "aspectRatio": 0.2,
      "openRate": 24.324,
      "solar": 274.7,
      "temperature": 25.3,
      "rh": 62.0,
      "vpd": 1.2254,
      "co2": 435
    },
    {
      "time": "09:59:38",
      "side": "east",
      "aperture": 2.414,
      "poreArea": 22.3256,
      "aspectRatio": 0.19423,
      "openRate": 42.857,
      "solar": 388.9,
      "temperature": 24.3,
      "rh": 68.0,
      "vpd": 0.9722,
      "co2": 423
    },
    {
      "time": "09:59:50",
      "side": "east",
      "aperture": 4.1533,
      "poreArea": 42.93,
      "aspectRatio": 0.29805,
      "openRate": 97.872,
      "solar": 388.9,
      "temperature": 24.3,
      "rh": 68.0,
      "vpd": 0.9722,
      "co2": 423
    },
    {
      "time": "10:00:01",
      "side": "east",
      "aperture": 4.2491,
      "poreArea": 52.65,
      "aspectRatio": 0.28405,
      "openRate": 93.333,
      "solar": 388.9,
      "temperature": 24.3,
      "rh": 68.0,
      "vpd": 0.9722,
      "co2": 423
    },
    {
      "time": "10:00:08",
      "side": "east",
      "aperture": 4.4487,
      "poreArea": 52.4475,
      "aspectRatio": 0.26417,
      "openRate": 100.0,
      "solar": 388.9,
      "temperature": 24.3,
      "rh": 68.0,
      "vpd": 0.9722,
      "co2": 423
    },
    {
      "time": "10:00:28",
      "side": "east",
      "aperture": 3.4894,
      "poreArea": 37.8169,
      "aspectRatio": 0.25686,
      "openRate": 92.308,
      "solar": 388.9,
      "temperature": 24.3,
      "rh": 68.0,
      "vpd": 0.9722,
      "co2": 423
    },
    {
      "time": "10:00:43",
      "side": "east",
      "aperture": 5.0171,
      "poreArea": 52.245,
      "aspectRatio": 0.36427,
      "openRate": 96.703,
      "solar": 383.0,
      "temperature": 24.3,
      "rh": 68.0,
      "vpd": 0.9722,
      "co2": 411
    },
    {
      "time": "10:00:58",
      "side": "east",
      "aperture": 2.6458,
      "poreArea": 26.0719,
      "aspectRatio": 0.16488,
      "openRate": 16.667,
      "solar": 383.0,
      "temperature": 24.3,
      "rh": 68.0,
      "vpd": 0.9722,
      "co2": 411
    },
    {
      "time": "10:03:00",
      "side": "east",
      "aperture": 4.8087,
      "poreArea": 54.1688,
      "aspectRatio": 0.29197,
      "openRate": 100.0,
      "solar": 342.7,
      "temperature": 24.3,
      "rh": 68.0,
      "vpd": 0.9722,
      "co2": 399
    },
    {
      "time": "10:03:08",
      "side": "east",
      "aperture": 4.935,
      "poreArea": 63.9394,
      "aspectRatio": 0.28326,
      "openRate": 100.0,
      "solar": 342.7,
      "temperature": 24.3,
      "rh": 68.0,
      "vpd": 0.9722,
      "co2": 399
    },
    {
      "time": "10:03:16",
      "side": "east",
      "aperture": 4.773,
      "poreArea": 55.89,
      "aspectRatio": 0.3,
      "openRate": 100.0,
      "solar": 342.7,
      "temperature": 24.3,
      "rh": 68.0,
      "vpd": 0.9722,
      "co2": 399
    },
    {
      "time": "10:03:24",
      "side": "east",
      "aperture": 5.3066,
      "poreArea": 51.84,
      "aspectRatio": 0.35563,
      "openRate": 100.0,
      "solar": 342.7,
      "temperature": 24.3,
      "rh": 68.0,
      "vpd": 0.9722,
      "co2": 399
    },
    {
      "time": "10:03:31",
      "side": "east",
      "aperture": 4.9768,
      "poreArea": 54.5738,
      "aspectRatio": 0.29268,
      "openRate": 100.0,
      "solar": 332.6,
      "temperature": 24.4,
      "rh": 66.5,
      "vpd": 1.0239,
      "co2": 399
    },
    {
      "time": "10:03:48",
      "side": "east",
      "aperture": 4.7168,
      "poreArea": 48.6506,
      "aspectRatio": 0.31438,
      "openRate": 100.0,
      "solar": 332.6,
      "temperature": 24.4,
      "rh": 66.5,
      "vpd": 1.0239,
      "co2": 399
    },
    {
      "time": "10:03:58",
      "side": "east",
      "aperture": 4.5,
      "poreArea": 45.8663,
      "aspectRatio": 0.28346,
      "openRate": 88.235,
      "solar": 332.6,
      "temperature": 24.4,
      "rh": 66.5,
      "vpd": 1.0239,
      "co2": 399
    },
    {
      "time": "10:04:05",
      "side": "east",
      "aperture": 4.4548,
      "poreArea": 49.7138,
      "aspectRatio": 0.28409,
      "openRate": 100.0,
      "solar": 332.6,
      "temperature": 24.4,
      "rh": 66.5,
      "vpd": 1.0239,
      "co2": 399
    },
    {
      "time": "10:04:19",
      "side": "east",
      "aperture": 3.6774,
      "poreArea": 45.6638,
      "aspectRatio": 0.23053,
      "openRate": 77.778,
      "solar": 332.6,
      "temperature": 24.4,
      "rh": 66.5,
      "vpd": 1.0239,
      "co2": 399
    },
    {
      "time": "10:04:32",
      "side": "east",
      "aperture": 4.7861,
      "poreArea": 53.3588,
      "aspectRatio": 0.33333,
      "openRate": 100.0,
      "solar": 416.6,
      "temperature": 24.4,
      "rh": 66.5,
      "vpd": 1.0239,
      "co2": 399
    },
    {
      "time": "10:13:06",
      "side": "east",
      "aperture": 3.4054,
      "poreArea": 38.3231,
      "aspectRatio": 0.22941,
      "openRate": 92.683,
      "solar": 608.2,
      "temperature": 25.5,
      "rh": 66.0,
      "vpd": 1.1095,
      "co2": 371
    },
    {
      "time": "10:13:12",
      "side": "east",
      "aperture": 3.8559,
      "poreArea": 44.0438,
      "aspectRatio": 0.23737,
      "openRate": 93.902,
      "solar": 608.2,
      "temperature": 25.5,
      "rh": 66.0,
      "vpd": 1.1095,
      "co2": 371
    },
    {
      "time": "10:13:23",
      "side": "east",
      "aperture": 3.9613,
      "poreArea": 43.8919,
      "aspectRatio": 0.24672,
      "openRate": 96.97,
      "solar": 608.2,
      "temperature": 25.5,
      "rh": 66.0,
      "vpd": 1.1095,
      "co2": 371
    },
    {
      "time": "10:13:50",
      "side": "east",
      "aperture": 4.4713,
      "poreArea": 52.8019,
      "aspectRatio": 0.26065,
      "openRate": 96.0,
      "solar": 602.3,
      "temperature": 25.7,
      "rh": 66.0,
      "vpd": 1.1228,
      "co2": 371
    },
    {
      "time": "10:13:56",
      "side": "east",
      "aperture": 3.6224,
      "poreArea": 41.4113,
      "aspectRatio": 0.23529,
      "openRate": 100.0,
      "solar": 602.3,
      "temperature": 25.7,
      "rh": 66.0,
      "vpd": 1.1228,
      "co2": 371
    },
    {
      "time": "10:14:03",
      "side": "east",
      "aperture": 3.5774,
      "poreArea": 37.4625,
      "aspectRatio": 0.23591,
      "openRate": 85.714,
      "solar": 602.3,
      "temperature": 25.7,
      "rh": 66.0,
      "vpd": 1.1228,
      "co2": 371
    },
    {
      "time": "10:14:09",
      "side": "east",
      "aperture": 4.0047,
      "poreArea": 43.0312,
      "aspectRatio": 0.26653,
      "openRate": 94.737,
      "solar": 602.3,
      "temperature": 25.7,
      "rh": 66.0,
      "vpd": 1.1228,
      "co2": 371
    },
    {
      "time": "10:14:25",
      "side": "east",
      "aperture": 3.4495,
      "poreArea": 34.5263,
      "aspectRatio": 0.24667,
      "openRate": 97.826,
      "solar": 602.3,
      "temperature": 25.7,
      "rh": 66.0,
      "vpd": 1.1228,
      "co2": 371
    },
    {
      "time": "10:19:47",
      "side": "east",
      "aperture": 3.6162,
      "poreArea": 43.9425,
      "aspectRatio": 0.22415,
      "openRate": 93.333,
      "solar": 429.2,
      "temperature": 26.5,
      "rh": 68.0,
      "vpd": 1.1079,
      "co2": 359
    },
    {
      "time": "10:19:54",
      "side": "east",
      "aperture": 4.05,
      "poreArea": 49.005,
      "aspectRatio": 0.26199,
      "openRate": 81.818,
      "solar": 429.2,
      "temperature": 26.5,
      "rh": 68.0,
      "vpd": 1.1079,
      "co2": 359
    },
    {
      "time": "10:20:01",
      "side": "east",
      "aperture": 3.2199,
      "poreArea": 33.615,
      "aspectRatio": 0.23129,
      "openRate": 93.939,
      "solar": 429.2,
      "temperature": 26.5,
      "rh": 68.0,
      "vpd": 1.1079,
      "co2": 359
    },
    {
      "time": "10:20:19",
      "side": "east",
      "aperture": 3.1563,
      "poreArea": 33.21,
      "aspectRatio": 0.20739,
      "openRate": 86.957,
      "solar": 429.2,
      "temperature": 26.5,
      "rh": 68.0,
      "vpd": 1.1079,
      "co2": 359
    },
    {
      "time": "10:20:39",
      "side": "east",
      "aperture": 3.0715,
      "poreArea": 31.185,
      "aspectRatio": 0.21254,
      "openRate": 82.692,
      "solar": 414.1,
      "temperature": 26.6,
      "rh": 68.0,
      "vpd": 1.1144,
      "co2": 359
    },
    {
      "time": "10:20:51",
      "side": "east",
      "aperture": 4.2149,
      "poreArea": 46.17,
      "aspectRatio": 0.27254,
      "openRate": 100.0,
      "solar": 414.1,
      "temperature": 26.6,
      "rh": 68.0,
      "vpd": 1.1144,
      "co2": 359
    },
    {
      "time": "10:20:58",
      "side": "east",
      "aperture": 4.2712,
      "poreArea": 48.0431,
      "aspectRatio": 0.25932,
      "openRate": 100.0,
      "solar": 414.1,
      "temperature": 26.6,
      "rh": 68.0,
      "vpd": 1.1144,
      "co2": 359
    },
    {
      "time": "10:21:05",
      "side": "east",
      "aperture": 4.0689,
      "poreArea": 48.7013,
      "aspectRatio": 0.24,
      "openRate": 94.915,
      "solar": 414.1,
      "temperature": 26.6,
      "rh": 68.0,
      "vpd": 1.1144,
      "co2": 359
    },
    {
      "time": "10:21:14",
      "side": "east",
      "aperture": 3.8869,
      "poreArea": 46.2713,
      "aspectRatio": 0.23629,
      "openRate": 100.0,
      "solar": 414.1,
      "temperature": 26.6,
      "rh": 68.0,
      "vpd": 1.1144,
      "co2": 359
    },
    {
      "time": "10:21:31",
      "side": "east",
      "aperture": 3.5722,
      "poreArea": 41.0063,
      "aspectRatio": 0.24419,
      "openRate": 98.485,
      "solar": 524.2,
      "temperature": 26.6,
      "rh": 67.0,
      "vpd": 1.1492,
      "co2": 359
    },
    {
      "time": "10:34:24",
      "side": "east",
      "aperture": 4.4331,
      "poreArea": 46.8281,
      "aspectRatio": 0.31054,
      "openRate": 97.959,
      "solar": 650.6,
      "temperature": 26.8,
      "rh": 64.0,
      "vpd": 1.2685,
      "co2": 355
    },
    {
      "time": "10:34:32",
      "side": "east",
      "aperture": 4.8022,
      "poreArea": 49.41,
      "aspectRatio": 0.33663,
      "openRate": 100.0,
      "solar": 670.3,
      "temperature": 26.9,
      "rh": 65.0,
      "vpd": 1.2406,
      "co2": 355
    },
    {
      "time": "10:34:42",
      "side": "east",
      "aperture": 6.3542,
      "poreArea": 68.6475,
      "aspectRatio": 0.41379,
      "openRate": 96.226,
      "solar": 670.3,
      "temperature": 26.9,
      "rh": 65.0,
      "vpd": 1.2406,
      "co2": 355
    },
    {
      "time": "10:36:32",
      "side": "east",
      "aperture": 5.3083,
      "poreArea": 53.5613,
      "aspectRatio": 0.33233,
      "openRate": 100.0,
      "solar": 683.8,
      "temperature": 27.1,
      "rh": 62.0,
      "vpd": 1.3628,
      "co2": 355
    },
    {
      "time": "10:36:41",
      "side": "east",
      "aperture": 4.6093,
      "poreArea": 46.9294,
      "aspectRatio": 0.32222,
      "openRate": 98.361,
      "solar": 683.8,
      "temperature": 27.1,
      "rh": 62.0,
      "vpd": 1.3628,
      "co2": 355
    },
    {
      "time": "10:36:52",
      "side": "east",
      "aperture": 5.4,
      "poreArea": 57.7125,
      "aspectRatio": 0.35152,
      "openRate": 98.333,
      "solar": 683.8,
      "temperature": 27.1,
      "rh": 62.0,
      "vpd": 1.3628,
      "co2": 355
    },
    {
      "time": "10:37:13",
      "side": "east",
      "aperture": 3.6,
      "poreArea": 38.88,
      "aspectRatio": 0.24138,
      "openRate": 100.0,
      "solar": 683.8,
      "temperature": 27.1,
      "rh": 62.0,
      "vpd": 1.3628,
      "co2": 355
    },
    {
      "time": "10:37:27",
      "side": "east",
      "aperture": 5.4094,
      "poreArea": 62.37,
      "aspectRatio": 0.31481,
      "openRate": 100.0,
      "solar": 683.8,
      "temperature": 27.1,
      "rh": 62.0,
      "vpd": 1.3628,
      "co2": 355
    },
    {
      "time": "10:37:45",
      "side": "east",
      "aperture": 4.9421,
      "poreArea": 57.8137,
      "aspectRatio": 0.32558,
      "openRate": 100.0,
      "solar": 683.8,
      "temperature": 27.1,
      "rh": 64.0,
      "vpd": 1.2911,
      "co2": 355
    },
    {
      "time": "10:40:47",
      "side": "east",
      "aperture": 4.8299,
      "poreArea": 56.5988,
      "aspectRatio": 0.30258,
      "openRate": 100.0,
      "solar": 687.1,
      "temperature": 27.4,
      "rh": 65.0,
      "vpd": 1.2775,
      "co2": 355
    },
    {
      "time": "10:41:03",
      "side": "east",
      "aperture": 4.6101,
      "poreArea": 58.5731,
      "aspectRatio": 0.2892,
      "openRate": 100.0,
      "solar": 687.1,
      "temperature": 27.4,
      "rh": 65.0,
      "vpd": 1.2775,
      "co2": 355
    },
    {
      "time": "10:42:37",
      "side": "east",
      "aperture": 4.2975,
      "poreArea": 42.6263,
      "aspectRatio": 0.29545,
      "openRate": 100.0,
      "solar": 695.5,
      "temperature": 27.6,
      "rh": 65.0,
      "vpd": 1.2925,
      "co2": 355
    },
    {
      "time": "10:42:52",
      "side": "east",
      "aperture": 5.4518,
      "poreArea": 66.5213,
      "aspectRatio": 0.33385,
      "openRate": 96.296,
      "solar": 695.5,
      "temperature": 27.6,
      "rh": 65.0,
      "vpd": 1.2925,
      "co2": 355
    },
    {
      "time": "10:43:06",
      "side": "east",
      "aperture": 4.8299,
      "poreArea": 63.0788,
      "aspectRatio": 0.29268,
      "openRate": 95.161,
      "solar": 695.5,
      "temperature": 27.6,
      "rh": 65.0,
      "vpd": 1.2925,
      "co2": 355
    },
    {
      "time": "10:45:04",
      "side": "east",
      "aperture": 4.6609,
      "poreArea": 47.3344,
      "aspectRatio": 0.37697,
      "openRate": 100.0,
      "solar": 703.9,
      "temperature": 27.8,
      "rh": 69.0,
      "vpd": 1.1582,
      "co2": 355
    },
    {
      "time": "10:45:14",
      "side": "east",
      "aperture": 4.5,
      "poreArea": 39.4369,
      "aspectRatio": 0.35778,
      "openRate": 97.959,
      "solar": 703.9,
      "temperature": 27.8,
      "rh": 69.0,
      "vpd": 1.1582,
      "co2": 355
    },
    {
      "time": "10:45:49",
      "side": "east",
      "aperture": 3.7941,
      "poreArea": 36.8044,
      "aspectRatio": 0.29438,
      "openRate": 100.0,
      "solar": 704.8,
      "temperature": 28.0,
      "rh": 66.0,
      "vpd": 1.2852,
      "co2": 355
    },
    {
      "time": "10:47:36",
      "side": "east",
      "aperture": 3.956,
      "poreArea": 38.7788,
      "aspectRatio": 0.30333,
      "openRate": 98.276,
      "solar": 714.8,
      "temperature": 28.3,
      "rh": 67.0,
      "vpd": 1.2693,
      "co2": 355
    },
    {
      "time": "10:48:06",
      "side": "east",
      "aperture": 6.1012,
      "poreArea": 66.42,
      "aspectRatio": 0.375,
      "openRate": 96.825,
      "solar": 714.8,
      "temperature": 28.3,
      "rh": 67.0,
      "vpd": 1.2693,
      "co2": 355
    },
    {
      "time": "10:48:37",
      "side": "east",
      "aperture": 3.4925,
      "poreArea": 29.97,
      "aspectRatio": 0.3,
      "openRate": 100.0,
      "solar": 719.0,
      "temperature": 28.4,
      "rh": 68.0,
      "vpd": 1.238,
      "co2": 355
    },
    {
      "time": "10:53:52",
      "side": "east",
      "aperture": 4.4014,
      "poreArea": 48.8531,
      "aspectRatio": 0.28098,
      "openRate": 96.552,
      "solar": 693.8,
      "temperature": 29.6,
      "rh": 68.0,
      "vpd": 1.3269,
      "co2": 355
    },
    {
      "time": "10:54:08",
      "side": "east",
      "aperture": 6.3838,
      "poreArea": 69.0525,
      "aspectRatio": 0.40211,
      "openRate": 97.826,
      "solar": 693.8,
      "temperature": 29.6,
      "rh": 68.0,
      "vpd": 1.3269,
      "co2": 355
    },
    {
      "time": "10:54:18",
      "side": "east",
      "aperture": 5.9887,
      "poreArea": 66.2175,
      "aspectRatio": 0.39697,
      "openRate": 100.0,
      "solar": 693.8,
      "temperature": 29.6,
      "rh": 68.0,
      "vpd": 1.3269,
      "co2": 355
    },
    {
      "time": "10:54:35",
      "side": "east",
      "aperture": 6.0735,
      "poreArea": 74.4188,
      "aspectRatio": 0.38725,
      "openRate": 100.0,
      "solar": 691.3,
      "temperature": 29.8,
      "rh": 68.0,
      "vpd": 1.3423,
      "co2": 355
    },
    {
      "time": "10:54:48",
      "side": "east",
      "aperture": 6.0814,
      "poreArea": 76.0387,
      "aspectRatio": 0.37071,
      "openRate": 100.0,
      "solar": 691.3,
      "temperature": 29.8,
      "rh": 68.0,
      "vpd": 1.3423,
      "co2": 355
    },
    {
      "time": "10:54:58",
      "side": "east",
      "aperture": 4.4761,
      "poreArea": 41.2088,
      "aspectRatio": 0.25581,
      "openRate": 71.429,
      "solar": 691.3,
      "temperature": 29.8,
      "rh": 68.0,
      "vpd": 1.3423,
      "co2": 355
    },
    {
      "time": "10:55:14",
      "side": "east",
      "aperture": 5.0273,
      "poreArea": 52.8525,
      "aspectRatio": 0.37022,
      "openRate": 95.652,
      "solar": 691.3,
      "temperature": 29.8,
      "rh": 68.0,
      "vpd": 1.3423,
      "co2": 355
    },
    {
      "time": "10:55:21",
      "side": "east",
      "aperture": 4.8087,
      "poreArea": 53.7638,
      "aspectRatio": 0.32995,
      "openRate": 100.0,
      "solar": 691.3,
      "temperature": 29.8,
      "rh": 68.0,
      "vpd": 1.3423,
      "co2": 355
    },
    {
      "time": "10:55:29",
      "side": "east",
      "aperture": 4.8014,
      "poreArea": 50.9794,
      "aspectRatio": 0.34188,
      "openRate": 100.0,
      "solar": 691.3,
      "temperature": 29.8,
      "rh": 68.0,
      "vpd": 1.3423,
      "co2": 355
    },
    {
      "time": "10:55:40",
      "side": "east",
      "aperture": 5.8001,
      "poreArea": 57.2569,
      "aspectRatio": 0.40825,
      "openRate": 100.0,
      "solar": 685.4,
      "temperature": 30.0,
      "rh": 67.0,
      "vpd": 1.4002,
      "co2": 355
    },
    {
      "time": "11:02:14",
      "side": "east",
      "aperture": 4.9761,
      "poreArea": 66.4706,
      "aspectRatio": 0.26443,
      "openRate": 100.0,
      "solar": 601.4,
      "temperature": 29.4,
      "rh": 62.0,
      "vpd": 1.5577,
      "co2": 395
    },
    {
      "time": "11:02:22",
      "side": "east",
      "aperture": 6.0156,
      "poreArea": 71.28,
      "aspectRatio": 0.35074,
      "openRate": 100.0,
      "solar": 601.4,
      "temperature": 29.4,
      "rh": 62.0,
      "vpd": 1.5577,
      "co2": 395
    },
    {
      "time": "11:02:37",
      "side": "east",
      "aperture": 4.5,
      "poreArea": 59.7375,
      "aspectRatio": 0.25882,
      "openRate": 95.714,
      "solar": 646.0,
      "temperature": 29.3,
      "rh": 62.0,
      "vpd": 1.5487,
      "co2": 395
    },
    {
      "time": "11:02:45",
      "side": "east",
      "aperture": 4.5,
      "poreArea": 54.675,
      "aspectRatio": 0.26636,
      "openRate": 95.588,
      "solar": 646.0,
      "temperature": 29.3,
      "rh": 62.0,
      "vpd": 1.5487,
      "co2": 395
    },
    {
      "time": "11:02:53",
      "side": "east",
      "aperture": 4.8675,
      "poreArea": 60.6488,
      "aspectRatio": 0.26829,
      "openRate": 100.0,
      "solar": 646.0,
      "temperature": 29.3,
      "rh": 62.0,
      "vpd": 1.5487,
      "co2": 395
    },
    {
      "time": "11:03:05",
      "side": "east",
      "aperture": 5.2385,
      "poreArea": 65.9137,
      "aspectRatio": 0.29851,
      "openRate": 98.438,
      "solar": 646.0,
      "temperature": 29.3,
      "rh": 62.0,
      "vpd": 1.5487,
      "co2": 395
    },
    {
      "time": "11:03:28",
      "side": "east",
      "aperture": 5.6804,
      "poreArea": 72.1913,
      "aspectRatio": 0.2964,
      "openRate": 100.0,
      "solar": 646.0,
      "temperature": 29.3,
      "rh": 62.0,
      "vpd": 1.5487,
      "co2": 395
    },
    {
      "time": "11:03:52",
      "side": "east",
      "aperture": 5.7727,
      "poreArea": 73.4062,
      "aspectRatio": 0.3349,
      "openRate": 100.0,
      "solar": 612.4,
      "temperature": 29.4,
      "rh": 62.5,
      "vpd": 1.5372,
      "co2": 405
    },
    {
      "time": "11:03:55",
      "side": "east",
      "aperture": 5.3496,
      "poreArea": 70.5713,
      "aspectRatio": 0.28571,
      "openRate": 100.0,
      "solar": 612.4,
      "temperature": 29.4,
      "rh": 62.5,
      "vpd": 1.5372,
      "co2": 405
    },
    {
      "time": "11:04:10",
      "side": "east",
      "aperture": 4.0375,
      "poreArea": 44.9044,
      "aspectRatio": 0.27429,
      "openRate": 95.522,
      "solar": 612.4,
      "temperature": 29.4,
      "rh": 62.5,
      "vpd": 1.5372,
      "co2": 405
    },
    {
      "time": "11:09:27",
      "side": "east",
      "aperture": 5.0312,
      "poreArea": 61.3575,
      "aspectRatio": 0.34768,
      "openRate": 100.0,
      "solar": 637.6,
      "temperature": 29.6,
      "rh": 62.0,
      "vpd": 1.5757,
      "co2": 419
    },
    {
      "time": "11:09:34",
      "side": "east",
      "aperture": 6.0458,
      "poreArea": 76.14,
      "aspectRatio": 0.31694,
      "openRate": 96.078,
      "solar": 635.9,
      "temperature": 29.7,
      "rh": 64.0,
      "vpd": 1.5014,
      "co2": 419
    },
    {
      "time": "11:09:48",
      "side": "east",
      "aperture": 4.7956,
      "poreArea": 64.395,
      "aspectRatio": 0.24126,
      "openRate": 100.0,
      "solar": 635.9,
      "temperature": 29.7,
      "rh": 64.0,
      "vpd": 1.5014,
      "co2": 419
    },
    {
      "time": "11:09:58",
      "side": "east",
      "aperture": 4.2084,
      "poreArea": 52.3463,
      "aspectRatio": 0.26531,
      "openRate": 96.923,
      "solar": 635.9,
      "temperature": 29.7,
      "rh": 64.0,
      "vpd": 1.5014,
      "co2": 419
    },
    {
      "time": "11:10:29",
      "side": "east",
      "aperture": 3.7044,
      "poreArea": 46.0688,
      "aspectRatio": 0.25843,
      "openRate": 90.625,
      "solar": 635.9,
      "temperature": 29.7,
      "rh": 64.0,
      "vpd": 1.5014,
      "co2": 419
    },
    {
      "time": "11:10:42",
      "side": "east",
      "aperture": 5.1186,
      "poreArea": 51.6375,
      "aspectRatio": 0.34071,
      "openRate": 97.059,
      "solar": 639.2,
      "temperature": 29.6,
      "rh": 66.0,
      "vpd": 1.4099,
      "co2": 419
    },
    {
      "time": "11:11:12",
      "side": "east",
      "aperture": 5.0912,
      "poreArea": 70.7231,
      "aspectRatio": 0.29239,
      "openRate": 95.522,
      "solar": 639.2,
      "temperature": 29.6,
      "rh": 66.0,
      "vpd": 1.4099,
      "co2": 419
    },
    {
      "time": "11:11:20",
      "side": "east",
      "aperture": 5.1296,
      "poreArea": 65.1038,
      "aspectRatio": 0.31319,
      "openRate": 93.443,
      "solar": 639.2,
      "temperature": 29.6,
      "rh": 66.0,
      "vpd": 1.4099,
      "co2": 419
    },
    {
      "time": "11:11:27",
      "side": "east",
      "aperture": 4.5268,
      "poreArea": 57.4594,
      "aspectRatio": 0.268,
      "openRate": 100.0,
      "solar": 639.2,
      "temperature": 29.6,
      "rh": 66.0,
      "vpd": 1.4099,
      "co2": 419
    },
    {
      "time": "11:25:04",
      "side": "east",
      "aperture": 6.1739,
      "poreArea": 58.6238,
      "aspectRatio": 0.44,
      "openRate": 100.0,
      "solar": 643.4,
      "temperature": 28.9,
      "rh": 66.0,
      "vpd": 1.3541,
      "co2": 367
    },
    {
      "time": "11:25:13",
      "side": "east",
      "aperture": 6.0458,
      "poreArea": 60.1425,
      "aspectRatio": 0.42857,
      "openRate": 100.0,
      "solar": 643.4,
      "temperature": 28.9,
      "rh": 66.0,
      "vpd": 1.3541,
      "co2": 367
    },
    {
      "time": "11:25:31",
      "side": "east",
      "aperture": 6.6822,
      "poreArea": 67.23,
      "aspectRatio": 0.46828,
      "openRate": 96.552,
      "solar": 643.4,
      "temperature": 28.9,
      "rh": 68.0,
      "vpd": 1.2744,
      "co2": 367
    },
    {
      "time": "11:25:39",
      "side": "east",
      "aperture": 6.3075,
      "poreArea": 69.5588,
      "aspectRatio": 0.4726,
      "openRate": 100.0,
      "solar": 643.4,
      "temperature": 28.9,
      "rh": 68.0,
      "vpd": 1.2744,
      "co2": 367
    },
    {
      "time": "11:25:47",
      "side": "east",
      "aperture": 7.4184,
      "poreArea": 85.7081,
      "aspectRatio": 0.47694,
      "openRate": 100.0,
      "solar": 643.4,
      "temperature": 28.9,
      "rh": 68.0,
      "vpd": 1.2744,
      "co2": 367
    },
    {
      "time": "11:26:27",
      "side": "east",
      "aperture": 5.9437,
      "poreArea": 60.0413,
      "aspectRatio": 0.42951,
      "openRate": 97.872,
      "solar": 643.4,
      "temperature": 28.9,
      "rh": 68.0,
      "vpd": 1.2744,
      "co2": 367
    },
    {
      "time": "11:26:48",
      "side": "east",
      "aperture": 3.8184,
      "poreArea": 36.045,
      "aspectRatio": 0.30435,
      "openRate": 86.667,
      "solar": 644.3,
      "temperature": 28.8,
      "rh": 67.0,
      "vpd": 1.3067,
      "co2": 367
    },
    {
      "time": "11:33:09",
      "side": "east",
      "aperture": 3.908,
      "poreArea": 35.3869,
      "aspectRatio": 0.29551,
      "openRate": 92.683,
      "solar": 646.0,
      "temperature": 29.1,
      "rh": 68.0,
      "vpd": 1.2892,
      "co2": 351
    },
    {
      "time": "11:33:21",
      "side": "east",
      "aperture": 3.4212,
      "poreArea": 28.9575,
      "aspectRatio": 0.28814,
      "openRate": 100.0,
      "solar": 646.0,
      "temperature": 29.1,
      "rh": 68.0,
      "vpd": 1.2892,
      "co2": 351
    },
    {
      "time": "11:33:28",
      "side": "east",
      "aperture": 3.9132,
      "poreArea": 36.5006,
      "aspectRatio": 0.33489,
      "openRate": 100.0,
      "solar": 646.0,
      "temperature": 29.1,
      "rh": 68.0,
      "vpd": 1.2892,
      "co2": 351
    },
    {
      "time": "11:33:39",
      "side": "east",
      "aperture": 4.8568,
      "poreArea": 41.4619,
      "aspectRatio": 0.40765,
      "openRate": 100.0,
      "solar": 646.8,
      "temperature": 29.2,
      "rh": 69.0,
      "vpd": 1.2562,
      "co2": 351
    },
    {
      "time": "11:33:53",
      "side": "east",
      "aperture": 3.2431,
      "poreArea": 28.1981,
      "aspectRatio": 0.26979,
      "openRate": 80.0,
      "solar": 646.8,
      "temperature": 29.2,
      "rh": 69.0,
      "vpd": 1.2562,
      "co2": 351
    },
    {
      "time": "11:37:48",
      "side": "east",
      "aperture": 4.3218,
      "poreArea": 50.9288,
      "aspectRatio": 0.26168,
      "openRate": 2.222,
      "solar": 647.6,
      "temperature": 29.5,
      "rh": 72.0,
      "vpd": 1.1544,
      "co2": 339
    },
    {
      "time": "12:12:54",
      "side": "switch",
      "aperture": 3.6908,
      "poreArea": 44.55,
      "aspectRatio": 0.22842,
      "openRate": 95.522,
      "solar": 664.4,
      "temperature": 29.6,
      "rh": 71.0,
      "vpd": 1.2025,
      "co2": 339
    },
    {
      "time": "12:13:12",
      "side": "switch",
      "aperture": 3.8921,
      "poreArea": 41.1075,
      "aspectRatio": 0.2678,
      "openRate": 90.476,
      "solar": 664.4,
      "temperature": 29.6,
      "rh": 71.0,
      "vpd": 1.2025,
      "co2": 339
    },
    {
      "time": "12:13:19",
      "side": "switch",
      "aperture": 3.9451,
      "poreArea": 41.31,
      "aspectRatio": 0.28642,
      "openRate": 95.652,
      "solar": 664.4,
      "temperature": 29.6,
      "rh": 71.0,
      "vpd": 1.2025,
      "co2": 339
    },
    {
      "time": "12:13:29",
      "side": "switch",
      "aperture": 3.5002,
      "poreArea": 30.2738,
      "aspectRatio": 0.25525,
      "openRate": 91.667,
      "solar": 664.4,
      "temperature": 29.6,
      "rh": 71.0,
      "vpd": 1.2025,
      "co2": 339
    },
    {
      "time": "12:13:37",
      "side": "switch",
      "aperture": 3.15,
      "poreArea": 26.5275,
      "aspectRatio": 0.26667,
      "openRate": 37.5,
      "solar": 662.8,
      "temperature": 29.6,
      "rh": 72.0,
      "vpd": 1.1611,
      "co2": 339
    },
    {
      "time": "12:15:17",
      "side": "switch",
      "aperture": 4.5867,
      "poreArea": 51.7388,
      "aspectRatio": 0.31034,
      "openRate": 95.833,
      "solar": 664.4,
      "temperature": 29.5,
      "rh": 71.0,
      "vpd": 1.1956,
      "co2": 327
    },
    {
      "time": "12:15:24",
      "side": "switch",
      "aperture": 5.9393,
      "poreArea": 62.3194,
      "aspectRatio": 0.40373,
      "openRate": 97.143,
      "solar": 664.4,
      "temperature": 29.5,
      "rh": 71.0,
      "vpd": 1.1956,
      "co2": 327
    },
    {
      "time": "12:15:31",
      "side": "switch",
      "aperture": 6.4885,
      "poreArea": 66.9262,
      "aspectRatio": 0.44,
      "openRate": 100.0,
      "solar": 668.6,
      "temperature": 29.4,
      "rh": 70.0,
      "vpd": 1.2298,
      "co2": 327
    },
    {
      "time": "12:15:38",
      "side": "switch",
      "aperture": 3.1618,
      "poreArea": 30.0206,
      "aspectRatio": 0.22737,
      "openRate": 80.0,
      "solar": 668.6,
      "temperature": 29.4,
      "rh": 70.0,
      "vpd": 1.2298,
      "co2": 327
    },
    {
      "time": "12:15:53",
      "side": "switch",
      "aperture": 6.6822,
      "poreArea": 78.2663,
      "aspectRatio": 0.44872,
      "openRate": 100.0,
      "solar": 668.6,
      "temperature": 29.4,
      "rh": 70.0,
      "vpd": 1.2298,
      "co2": 327
    },
    {
      "time": "12:19:13",
      "side": "switch",
      "aperture": 2.3346,
      "poreArea": 18.9338,
      "aspectRatio": 0.21739,
      "openRate": 25.0,
      "solar": 662.8,
      "temperature": 28.9,
      "rh": 72.0,
      "vpd": 1.1151,
      "co2": 327
    },
    {
      "time": "12:19:23",
      "side": "switch",
      "aperture": 3.6209,
      "poreArea": 38.8294,
      "aspectRatio": 0.26606,
      "openRate": 66.667,
      "solar": 662.8,
      "temperature": 28.9,
      "rh": 72.0,
      "vpd": 1.1151,
      "co2": 327
    },
    {
      "time": "12:19:52",
      "side": "switch",
      "aperture": 6.1156,
      "poreArea": 73.2038,
      "aspectRatio": 0.37143,
      "openRate": 100.0,
      "solar": 664.4,
      "temperature": 28.8,
      "rh": 72.0,
      "vpd": 1.1087,
      "co2": 327
    },
    {
      "time": "12:20:19",
      "side": "switch",
      "aperture": 6.1739,
      "poreArea": 49.9162,
      "aspectRatio": 0.46154,
      "openRate": 100.0,
      "solar": 664.4,
      "temperature": 28.8,
      "rh": 72.0,
      "vpd": 1.1087,
      "co2": 327
    },
    {
      "time": "12:21:09",
      "side": "switch",
      "aperture": 2.596,
      "poreArea": 24.705,
      "aspectRatio": 0.20642,
      "openRate": 56.818,
      "solar": 664.4,
      "temperature": 28.9,
      "rh": 74.0,
      "vpd": 1.0355,
      "co2": 327
    },
    {
      "time": "12:29:08",
      "side": "switch",
      "aperture": 7.3655,
      "poreArea": 93.3525,
      "aspectRatio": 0.44737,
      "openRate": 97.297,
      "solar": 661.1,
      "temperature": 28.7,
      "rh": 68.0,
      "vpd": 1.2598,
      "co2": 347
    },
    {
      "time": "12:31:27",
      "side": "switch",
      "aperture": 8.4039,
      "poreArea": 110.2613,
      "aspectRatio": 0.47354,
      "openRate": 100.0,
      "solar": 664.4,
      "temperature": 28.7,
      "rh": 70.0,
      "vpd": 1.181,
      "co2": 363
    },
    {
      "time": "12:31:35",
      "side": "switch",
      "aperture": 9.45,
      "poreArea": 148.23,
      "aspectRatio": 0.42557,
      "openRate": 93.548,
      "solar": 661.1,
      "temperature": 28.6,
      "rh": 68.0,
      "vpd": 1.2525,
      "co2": 363
    },
    {
      "time": "12:31:57",
      "side": "switch",
      "aperture": 8.55,
      "poreArea": 122.31,
      "aspectRatio": 0.38596,
      "openRate": 98.387,
      "solar": 661.1,
      "temperature": 28.6,
      "rh": 68.0,
      "vpd": 1.2525,
      "co2": 363
    },
    {
      "time": "12:37:41",
      "side": "switch",
      "aperture": 7.65,
      "poreArea": 95.985,
      "aspectRatio": 0.43439,
      "openRate": 100.0,
      "solar": 656.9,
      "temperature": 28.9,
      "rh": 72.0,
      "vpd": 1.1151,
      "co2": 379
    },
    {
      "time": "12:37:48",
      "side": "switch",
      "aperture": 8.022,
      "poreArea": 102.87,
      "aspectRatio": 0.4359,
      "openRate": 100.0,
      "solar": 656.9,
      "temperature": 28.9,
      "rh": 72.0,
      "vpd": 1.1151,
      "co2": 379
    },
    {
      "time": "12:38:31",
      "side": "switch",
      "aperture": 7.3152,
      "poreArea": 96.1369,
      "aspectRatio": 0.41463,
      "openRate": 98.246,
      "solar": 656.9,
      "temperature": 29.1,
      "rh": 72.0,
      "vpd": 1.1281,
      "co2": 391
    },
    {
      "time": "12:38:46",
      "side": "switch",
      "aperture": 7.4461,
      "poreArea": 102.3637,
      "aspectRatio": 0.40476,
      "openRate": 100.0,
      "solar": 656.9,
      "temperature": 29.1,
      "rh": 72.0,
      "vpd": 1.1281,
      "co2": 391
    },
    {
      "time": "12:44:46",
      "side": "switch",
      "aperture": 7.4904,
      "poreArea": 101.8575,
      "aspectRatio": 0.41738,
      "openRate": 100.0,
      "solar": 656.9,
      "temperature": 30.0,
      "rh": 68.0,
      "vpd": 1.3578,
      "co2": 391
    },
    {
      "time": "12:44:53",
      "side": "switch",
      "aperture": 7.006,
      "poreArea": 88.9988,
      "aspectRatio": 0.39551,
      "openRate": 95.455,
      "solar": 656.9,
      "temperature": 30.0,
      "rh": 68.0,
      "vpd": 1.3578,
      "co2": 391
    },
    {
      "time": "12:45:08",
      "side": "switch",
      "aperture": 7.0278,
      "poreArea": 90.2138,
      "aspectRatio": 0.38144,
      "openRate": 92.593,
      "solar": 656.9,
      "temperature": 30.0,
      "rh": 68.0,
      "vpd": 1.3578,
      "co2": 391
    },
    {
      "time": "12:55:58",
      "side": "switch",
      "aperture": 6.9541,
      "poreArea": 87.6825,
      "aspectRatio": 0.36407,
      "openRate": 100.0,
      "solar": 650.2,
      "temperature": 31.0,
      "rh": 66.0,
      "vpd": 1.5275,
      "co2": 379
    },
    {
      "time": "12:56:41",
      "side": "switch",
      "aperture": 6.4036,
      "poreArea": 71.1788,
      "aspectRatio": 0.41038,
      "openRate": 100.0,
      "solar": 651.8,
      "temperature": 31.1,
      "rh": 68.0,
      "vpd": 1.4458,
      "co2": 367
    },
    {
      "time": "12:57:03",
      "side": "switch",
      "aperture": 4.2565,
      "poreArea": 52.0425,
      "aspectRatio": 0.26062,
      "openRate": 95.0,
      "solar": 651.8,
      "temperature": 31.1,
      "rh": 68.0,
      "vpd": 1.4458,
      "co2": 367
    },
    {
      "time": "12:59:54",
      "side": "switch",
      "aperture": 3.2931,
      "poreArea": 32.4,
      "aspectRatio": 0.24865,
      "openRate": 93.75,
      "solar": 646.0,
      "temperature": 31.8,
      "rh": 64.0,
      "vpd": 1.6925,
      "co2": 367
    },
    {
      "time": "13:00:16",
      "side": "west",
      "aperture": 9.3432,
      "poreArea": 113.8556,
      "aspectRatio": 0.57269,
      "openRate": 100.0,
      "solar": 646.0,
      "temperature": 31.8,
      "rh": 64.0,
      "vpd": 1.6925,
      "co2": 367
    },
    {
      "time": "13:00:29",
      "side": "west",
      "aperture": 9.2318,
      "poreArea": 110.0588,
      "aspectRatio": 0.56967,
      "openRate": 97.778,
      "solar": 646.0,
      "temperature": 31.8,
      "rh": 64.0,
      "vpd": 1.6925,
      "co2": 367
    },
    {
      "time": "13:03:15",
      "side": "west",
      "aperture": 6.6139,
      "poreArea": 77.8106,
      "aspectRatio": 0.33649,
      "openRate": 83.333,
      "solar": 644.3,
      "temperature": 32.8,
      "rh": 66.0,
      "vpd": 1.6912,
      "co2": 351
    },
    {
      "time": "13:03:29",
      "side": "west",
      "aperture": 8.55,
      "poreArea": 121.7025,
      "aspectRatio": 0.43478,
      "openRate": 100.0,
      "solar": 644.3,
      "temperature": 32.8,
      "rh": 66.0,
      "vpd": 1.6912,
      "co2": 351
    },
    {
      "time": "13:03:36",
      "side": "west",
      "aperture": 7.0942,
      "poreArea": 96.0863,
      "aspectRatio": 0.35821,
      "openRate": 100.0,
      "solar": 643.9,
      "temperature": 33.0,
      "rh": 66.0,
      "vpd": 1.7103,
      "co2": 351
    },
    {
      "time": "13:03:37",
      "side": "west",
      "aperture": 6.9545,
      "poreArea": 100.5919,
      "aspectRatio": 0.35139,
      "openRate": 98.63,
      "solar": 643.9,
      "temperature": 33.0,
      "rh": 66.0,
      "vpd": 1.7103,
      "co2": 351
    },
    {
      "time": "13:03:44",
      "side": "west",
      "aperture": 7.2356,
      "poreArea": 103.4269,
      "aspectRatio": 0.35397,
      "openRate": 100.0,
      "solar": 643.9,
      "temperature": 33.0,
      "rh": 66.0,
      "vpd": 1.7103,
      "co2": 351
    },
    {
      "time": "13:03:56",
      "side": "west",
      "aperture": 6.75,
      "poreArea": 96.795,
      "aspectRatio": 0.36527,
      "openRate": 92.5,
      "solar": 643.9,
      "temperature": 33.0,
      "rh": 66.0,
      "vpd": 1.7103,
      "co2": 351
    },
    {
      "time": "13:04:03",
      "side": "west",
      "aperture": 7.6198,
      "poreArea": 92.0363,
      "aspectRatio": 0.45633,
      "openRate": 100.0,
      "solar": 643.9,
      "temperature": 33.0,
      "rh": 66.0,
      "vpd": 1.7103,
      "co2": 351
    },
    {
      "time": "13:07:14",
      "side": "west",
      "aperture": 8.1,
      "poreArea": 105.0975,
      "aspectRatio": 0.43269,
      "openRate": 100.0,
      "solar": 641.8,
      "temperature": 33.6,
      "rh": 66.0,
      "vpd": 1.7687,
      "co2": 351
    },
    {
      "time": "13:07:22",
      "side": "west",
      "aperture": 6.5465,
      "poreArea": 77.4563,
      "aspectRatio": 0.38269,
      "openRate": 94.118,
      "solar": 641.8,
      "temperature": 33.6,
      "rh": 66.0,
      "vpd": 1.7687,
      "co2": 351
    },
    {
      "time": "13:07:30",
      "side": "west",
      "aperture": 7.3155,
      "poreArea": 91.3275,
      "aspectRatio": 0.42775,
      "openRate": 100.0,
      "solar": 641.8,
      "temperature": 33.6,
      "rh": 66.0,
      "vpd": 1.7687,
      "co2": 351
    },
    {
      "time": "13:07:39",
      "side": "west",
      "aperture": 7.3269,
      "poreArea": 98.3137,
      "aspectRatio": 0.39535,
      "openRate": 93.846,
      "solar": 644.3,
      "temperature": 33.8,
      "rh": 67.0,
      "vpd": 1.7359,
      "co2": 339
    },
    {
      "time": "13:07:49",
      "side": "west",
      "aperture": 8.5556,
      "poreArea": 108.2362,
      "aspectRatio": 0.46429,
      "openRate": 100.0,
      "solar": 644.3,
      "temperature": 33.8,
      "rh": 67.0,
      "vpd": 1.7359,
      "co2": 339
    },
    {
      "time": "13:07:58",
      "side": "west",
      "aperture": 8.2511,
      "poreArea": 113.805,
      "aspectRatio": 0.44939,
      "openRate": 100.0,
      "solar": 644.3,
      "temperature": 33.8,
      "rh": 67.0,
      "vpd": 1.7359,
      "co2": 339
    },
    {
      "time": "13:10:36",
      "side": "west",
      "aperture": 7.0436,
      "poreArea": 96.795,
      "aspectRatio": 0.37179,
      "openRate": 96.667,
      "solar": 640.1,
      "temperature": 34.8,
      "rh": 69.0,
      "vpd": 1.7239,
      "co2": 339
    },
    {
      "time": "13:11:33",
      "side": "west",
      "aperture": 8.0794,
      "poreArea": 109.5019,
      "aspectRatio": 0.40082,
      "openRate": 95.238,
      "solar": 635.0,
      "temperature": 35.2,
      "rh": 70.0,
      "vpd": 1.7055,
      "co2": 339
    },
    {
      "time": "13:11:42",
      "side": "west",
      "aperture": 7.5437,
      "poreArea": 95.1244,
      "aspectRatio": 0.42157,
      "openRate": 100.0,
      "solar": 635.0,
      "temperature": 35.2,
      "rh": 70.0,
      "vpd": 1.7055,
      "co2": 339
    },
    {
      "time": "13:12:05",
      "side": "west",
      "aperture": 6.0374,
      "poreArea": 84.9488,
      "aspectRatio": 0.3467,
      "openRate": 97.059,
      "solar": 635.0,
      "temperature": 35.2,
      "rh": 70.0,
      "vpd": 1.7055,
      "co2": 339
    },
    {
      "time": "13:24:09",
      "side": "west",
      "aperture": 5.4,
      "poreArea": 77.4562,
      "aspectRatio": 0.29487,
      "openRate": 97.727,
      "solar": 629.2,
      "temperature": 36.5,
      "rh": 70.0,
      "vpd": 1.8318,
      "co2": 363
    },
    {
      "time": "13:24:16",
      "side": "west",
      "aperture": 4.8516,
      "poreArea": 61.9144,
      "aspectRatio": 0.26569,
      "openRate": 92.0,
      "solar": 629.2,
      "temperature": 36.5,
      "rh": 70.0,
      "vpd": 1.8318,
      "co2": 363
    },
    {
      "time": "13:24:45",
      "side": "west",
      "aperture": 6.6822,
      "poreArea": 80.4938,
      "aspectRatio": 0.35065,
      "openRate": 97.917,
      "solar": 631.7,
      "temperature": 36.7,
      "rh": 70.0,
      "vpd": 1.8519,
      "co2": 363
    },
    {
      "time": "13:32:45",
      "side": "west",
      "aperture": 6.4045,
      "poreArea": 88.695,
      "aspectRatio": 0.36759,
      "openRate": 100.0,
      "solar": 619.1,
      "temperature": 33.4,
      "rh": 50.0,
      "vpd": 2.5721,
      "co2": 407
    },
    {
      "time": "13:33:08",
      "side": "west",
      "aperture": 6.4055,
      "poreArea": 84.0881,
      "aspectRatio": 0.33468,
      "openRate": 96.386,
      "solar": 619.1,
      "temperature": 33.4,
      "rh": 50.0,
      "vpd": 2.5721,
      "co2": 407
    },
    {
      "time": "13:33:15",
      "side": "west",
      "aperture": 6.5077,
      "poreArea": 81.81,
      "aspectRatio": 0.36655,
      "openRate": 100.0,
      "solar": 619.1,
      "temperature": 33.4,
      "rh": 50.0,
      "vpd": 2.5721,
      "co2": 407
    },
    {
      "time": "13:33:47",
      "side": "west",
      "aperture": 5.903,
      "poreArea": 73.1025,
      "aspectRatio": 0.33315,
      "openRate": 100.0,
      "solar": 618.2,
      "temperature": 32.9,
      "rh": 53.0,
      "vpd": 2.3509,
      "co2": 415
    },
    {
      "time": "13:34:09",
      "side": "west",
      "aperture": 5.6223,
      "poreArea": 70.3688,
      "aspectRatio": 0.2969,
      "openRate": 100.0,
      "solar": 618.2,
      "temperature": 32.9,
      "rh": 53.0,
      "vpd": 2.3509,
      "co2": 415
    },
    {
      "time": "13:34:18",
      "side": "west",
      "aperture": 6.5485,
      "poreArea": 83.1262,
      "aspectRatio": 0.33816,
      "openRate": 100.0,
      "solar": 618.2,
      "temperature": 32.9,
      "rh": 53.0,
      "vpd": 2.3509,
      "co2": 415
    },
    {
      "time": "13:34:29",
      "side": "west",
      "aperture": 7.6984,
      "poreArea": 104.2369,
      "aspectRatio": 0.42054,
      "openRate": 95.238,
      "solar": 618.2,
      "temperature": 32.9,
      "rh": 53.0,
      "vpd": 2.3509,
      "co2": 415
    },
    {
      "time": "13:37:12",
      "side": "west",
      "aperture": 3.1613,
      "poreArea": 34.9313,
      "aspectRatio": 0.2151,
      "openRate": 71.795,
      "solar": 616.6,
      "temperature": 33.1,
      "rh": 60.0,
      "vpd": 2.0234,
      "co2": 415
    },
    {
      "time": "13:37:25",
      "side": "west",
      "aperture": 2.6947,
      "poreArea": 29.97,
      "aspectRatio": 0.19316,
      "openRate": 35.849,
      "solar": 616.6,
      "temperature": 33.1,
      "rh": 60.0,
      "vpd": 2.0234,
      "co2": 415
    },
    {
      "time": "13:37:38",
      "side": "west",
      "aperture": 5.4336,
      "poreArea": 78.0637,
      "aspectRatio": 0.27027,
      "openRate": 100.0,
      "solar": 614.0,
      "temperature": 33.4,
      "rh": 61.0,
      "vpd": 2.0062,
      "co2": 415
    },
    {
      "time": "13:38:05",
      "side": "west",
      "aperture": 5.1788,
      "poreArea": 74.4188,
      "aspectRatio": 0.26214,
      "openRate": 98.75,
      "solar": 614.0,
      "temperature": 33.4,
      "rh": 61.0,
      "vpd": 2.0062,
      "co2": 415
    },
    {
      "time": "13:38:15",
      "side": "west",
      "aperture": 6.0374,
      "poreArea": 93.4538,
      "aspectRatio": 0.28378,
      "openRate": 100.0,
      "solar": 614.0,
      "temperature": 33.4,
      "rh": 61.0,
      "vpd": 2.0062,
      "co2": 415
    },
    {
      "time": "13:38:51",
      "side": "west",
      "aperture": 6.3,
      "poreArea": 88.1887,
      "aspectRatio": 0.31056,
      "openRate": 100.0,
      "solar": 614.0,
      "temperature": 33.6,
      "rh": 62.0,
      "vpd": 1.9767,
      "co2": 415
    },
    {
      "time": "13:39:14",
      "side": "west",
      "aperture": 4.3991,
      "poreArea": 56.2444,
      "aspectRatio": 0.25758,
      "openRate": 100.0,
      "solar": 614.0,
      "temperature": 33.6,
      "rh": 62.0,
      "vpd": 1.9767,
      "co2": 415
    },
    {
      "time": "13:39:56",
      "side": "west",
      "aperture": 5.2324,
      "poreArea": 67.23,
      "aspectRatio": 0.25859,
      "openRate": 100.0,
      "solar": 612.4,
      "temperature": 33.8,
      "rh": 63.0,
      "vpd": 1.9463,
      "co2": 415
    },
    {
      "time": "13:40:15",
      "side": "west",
      "aperture": 5.2788,
      "poreArea": 65.1544,
      "aspectRatio": 0.32144,
      "openRate": 98.551,
      "solar": 612.4,
      "temperature": 33.8,
      "rh": 63.0,
      "vpd": 1.9463,
      "co2": 415
    },
    {
      "time": "13:40:32",
      "side": "west",
      "aperture": 4.05,
      "poreArea": 44.2463,
      "aspectRatio": 0.2381,
      "openRate": 100.0,
      "solar": 608.2,
      "temperature": 34.0,
      "rh": 66.0,
      "vpd": 1.8085,
      "co2": 415
    },
    {
      "time": "13:45:47",
      "side": "west",
      "aperture": 6.2386,
      "poreArea": 91.2262,
      "aspectRatio": 0.30303,
      "openRate": 97.531,
      "solar": 602.3,
      "temperature": 34.4,
      "rh": 67.0,
      "vpd": 1.7948,
      "co2": 395
    },
    {
      "time": "13:46:00",
      "side": "west",
      "aperture": 5.5725,
      "poreArea": 86.3663,
      "aspectRatio": 0.2701,
      "openRate": 97.98,
      "solar": 602.3,
      "temperature": 34.4,
      "rh": 67.0,
      "vpd": 1.7948,
      "co2": 395
    },
    {
      "time": "14:01:47",
      "side": "west",
      "aperture": 3.1113,
      "poreArea": 34.3238,
      "aspectRatio": 0.19635,
      "openRate": 46.429,
      "solar": 578.8,
      "temperature": 33.4,
      "rh": 62.0,
      "vpd": 1.9548,
      "co2": 351
    },
    {
      "time": "14:02:02",
      "side": "west",
      "aperture": 3.8422,
      "poreArea": 44.55,
      "aspectRatio": 0.2438,
      "openRate": 95.556,
      "solar": 578.8,
      "temperature": 33.4,
      "rh": 62.0,
      "vpd": 1.9548,
      "co2": 351
    },
    {
      "time": "14:02:18",
      "side": "west",
      "aperture": 3.3093,
      "poreArea": 44.2463,
      "aspectRatio": 0.20463,
      "openRate": 65.385,
      "solar": 578.8,
      "temperature": 33.4,
      "rh": 62.0,
      "vpd": 1.9548,
      "co2": 351
    },
    {
      "time": "14:02:37",
      "side": "west",
      "aperture": 3.6943,
      "poreArea": 41.715,
      "aspectRatio": 0.23864,
      "openRate": 44.444,
      "solar": 574.6,
      "temperature": 33.3,
      "rh": 64.0,
      "vpd": 1.8415,
      "co2": 351
    },
    {
      "time": "14:04:26",
      "side": "west",
      "aperture": 5.377,
      "poreArea": 63.6863,
      "aspectRatio": 0.33333,
      "openRate": 100.0,
      "solar": 575.0,
      "temperature": 33.1,
      "rh": 62.0,
      "vpd": 1.9222,
      "co2": 351
    },
    {
      "time": "14:04:38",
      "side": "west",
      "aperture": 5.4655,
      "poreArea": 65.2556,
      "aspectRatio": 0.33333,
      "openRate": 98.305,
      "solar": 574.6,
      "temperature": 32.7,
      "rh": 62.0,
      "vpd": 1.8795,
      "co2": 351
    },
    {
      "time": "14:04:50",
      "side": "west",
      "aperture": 5.3613,
      "poreArea": 65.0531,
      "aspectRatio": 0.33259,
      "openRate": 98.592,
      "solar": 574.6,
      "temperature": 32.7,
      "rh": 62.0,
      "vpd": 1.8795,
      "co2": 351
    },
    {
      "time": "14:04:58",
      "side": "west",
      "aperture": 3.1754,
      "poreArea": 29.0588,
      "aspectRatio": 0.25,
      "openRate": 73.077,
      "solar": 574.6,
      "temperature": 32.7,
      "rh": 62.0,
      "vpd": 1.8795,
      "co2": 351
    },
    {
      "time": "14:05:04",
      "side": "west",
      "aperture": 5.0323,
      "poreArea": 60.4969,
      "aspectRatio": 0.32612,
      "openRate": 100.0,
      "solar": 574.6,
      "temperature": 32.7,
      "rh": 62.0,
      "vpd": 1.8795,
      "co2": 351
    },
    {
      "time": "14:16:31",
      "side": "west",
      "aperture": 3.6017,
      "poreArea": 38.2725,
      "aspectRatio": 0.22414,
      "openRate": 67.857,
      "solar": 557.8,
      "temperature": 33.3,
      "rh": 73.0,
      "vpd": 1.3812,
      "co2": 339
    },
    {
      "time": "14:16:37",
      "side": "west",
      "aperture": 4.0382,
      "poreArea": 47.385,
      "aspectRatio": 0.26316,
      "openRate": 95.556,
      "solar": 557.8,
      "temperature": 33.3,
      "rh": 73.0,
      "vpd": 1.3812,
      "co2": 339
    },
    {
      "time": "14:16:43",
      "side": "west",
      "aperture": 4.05,
      "poreArea": 50.8275,
      "aspectRatio": 0.26471,
      "openRate": 100.0,
      "solar": 557.8,
      "temperature": 33.3,
      "rh": 73.0,
      "vpd": 1.3812,
      "co2": 339
    },
    {
      "time": "14:16:56",
      "side": "west",
      "aperture": 4.6062,
      "poreArea": 58.5225,
      "aspectRatio": 0.26146,
      "openRate": 95.833,
      "solar": 557.8,
      "temperature": 33.3,
      "rh": 73.0,
      "vpd": 1.3812,
      "co2": 339
    },
    {
      "time": "14:22:09",
      "side": "west",
      "aperture": 3.2198,
      "poreArea": 48.6506,
      "aspectRatio": 0.16319,
      "openRate": 90.0,
      "solar": 546.0,
      "temperature": 33.0,
      "rh": 70.0,
      "vpd": 1.509,
      "co2": 351
    },
    {
      "time": "14:22:14",
      "side": "west",
      "aperture": 4.2032,
      "poreArea": 50.4225,
      "aspectRatio": 0.25301,
      "openRate": 100.0,
      "solar": 546.0,
      "temperature": 33.0,
      "rh": 70.0,
      "vpd": 1.509,
      "co2": 351
    },
    {
      "time": "14:22:21",
      "side": "west",
      "aperture": 4.9302,
      "poreArea": 59.7375,
      "aspectRatio": 0.28182,
      "openRate": 95.455,
      "solar": 546.0,
      "temperature": 33.0,
      "rh": 70.0,
      "vpd": 1.509,
      "co2": 351
    },
    {
      "time": "14:22:30",
      "side": "west",
      "aperture": 5.8361,
      "poreArea": 79.1775,
      "aspectRatio": 0.3252,
      "openRate": 97.917,
      "solar": 546.0,
      "temperature": 33.0,
      "rh": 70.0,
      "vpd": 1.509,
      "co2": 351
    },
    {
      "time": "14:22:50",
      "side": "west",
      "aperture": 3.5842,
      "poreArea": 37.3613,
      "aspectRatio": 0.24841,
      "openRate": 100.0,
      "solar": 541.0,
      "temperature": 32.9,
      "rh": 72.0,
      "vpd": 1.4006,
      "co2": 351
    },
    {
      "time": "14:23:00",
      "side": "west",
      "aperture": 5.7176,
      "poreArea": 75.6338,
      "aspectRatio": 0.30647,
      "openRate": 96.97,
      "solar": 541.0,
      "temperature": 32.9,
      "rh": 72.0,
      "vpd": 1.4006,
      "co2": 351
    },
    {
      "time": "14:25:21",
      "side": "west",
      "aperture": 5.0312,
      "poreArea": 66.3188,
      "aspectRatio": 0.27049,
      "openRate": 100.0,
      "solar": 537.6,
      "temperature": 32.7,
      "rh": 74.0,
      "vpd": 1.286,
      "co2": 363
    },
    {
      "time": "14:25:29",
      "side": "west",
      "aperture": 3.15,
      "poreArea": 33.5138,
      "aspectRatio": 0.23333,
      "openRate": 79.31,
      "solar": 537.6,
      "temperature": 32.7,
      "rh": 74.0,
      "vpd": 1.286,
      "co2": 363
    },
    {
      "time": "14:25:36",
      "side": "west",
      "aperture": 4.6954,
      "poreArea": 56.4975,
      "aspectRatio": 0.27985,
      "openRate": 100.0,
      "solar": 536.8,
      "temperature": 32.5,
      "rh": 74.0,
      "vpd": 1.2716,
      "co2": 363
    },
    {
      "time": "14:25:48",
      "side": "west",
      "aperture": 3.4418,
      "poreArea": 39.7912,
      "aspectRatio": 0.22414,
      "openRate": 79.167,
      "solar": 536.8,
      "temperature": 32.5,
      "rh": 74.0,
      "vpd": 1.2716,
      "co2": 363
    },
    {
      "time": "14:25:55",
      "side": "west",
      "aperture": 4.773,
      "poreArea": 61.0031,
      "aspectRatio": 0.2833,
      "openRate": 95.455,
      "solar": 536.8,
      "temperature": 32.5,
      "rh": 74.0,
      "vpd": 1.2716,
      "co2": 363
    },
    {
      "time": "14:34:37",
      "side": "west",
      "aperture": 5.1921,
      "poreArea": 60.4969,
      "aspectRatio": 0.31587,
      "openRate": 96.154,
      "solar": 512.4,
      "temperature": 30.7,
      "rh": 74.0,
      "vpd": 1.1483,
      "co2": 421
    },
    {
      "time": "14:34:50",
      "side": "west",
      "aperture": 3.3698,
      "poreArea": 34.83,
      "aspectRatio": 0.22222,
      "openRate": 85.185,
      "solar": 512.4,
      "temperature": 30.7,
      "rh": 74.0,
      "vpd": 1.1483,
      "co2": 421
    },
    {
      "time": "14:34:57",
      "side": "west",
      "aperture": 4.9653,
      "poreArea": 54.4725,
      "aspectRatio": 0.30461,
      "openRate": 100.0,
      "solar": 512.4,
      "temperature": 30.7,
      "rh": 74.0,
      "vpd": 1.1483,
      "co2": 421
    },
    {
      "time": "14:36:10",
      "side": "west",
      "aperture": 4.1803,
      "poreArea": 47.6381,
      "aspectRatio": 0.25039,
      "openRate": 94.118,
      "solar": 509.9,
      "temperature": 30.4,
      "rh": 73.0,
      "vpd": 1.1722,
      "co2": 443
    },
    {
      "time": "14:36:25",
      "side": "west",
      "aperture": 4.8134,
      "poreArea": 56.8519,
      "aspectRatio": 0.28445,
      "openRate": 98.039,
      "solar": 509.9,
      "temperature": 30.4,
      "rh": 73.0,
      "vpd": 1.1722,
      "co2": 443
    },
    {
      "time": "14:45:24",
      "side": "west",
      "aperture": 3.735,
      "poreArea": 40.7531,
      "aspectRatio": 0.25497,
      "openRate": 84.211,
      "solar": 488.9,
      "temperature": 28.3,
      "rh": 76.0,
      "vpd": 0.9232,
      "co2": 491
    },
    {
      "time": "14:45:31",
      "side": "west",
      "aperture": 3.7066,
      "poreArea": 44.55,
      "aspectRatio": 0.25167,
      "openRate": 92.857,
      "solar": 487.2,
      "temperature": 28.1,
      "rh": 76.0,
      "vpd": 0.9125,
      "co2": 491
    },
    {
      "time": "14:45:38",
      "side": "west",
      "aperture": 3.6197,
      "poreArea": 44.6006,
      "aspectRatio": 0.23937,
      "openRate": 90.909,
      "solar": 487.2,
      "temperature": 28.1,
      "rh": 76.0,
      "vpd": 0.9125,
      "co2": 491
    },
    {
      "time": "14:45:47",
      "side": "west",
      "aperture": 3.5305,
      "poreArea": 39.5381,
      "aspectRatio": 0.21881,
      "openRate": 93.75,
      "solar": 487.2,
      "temperature": 28.1,
      "rh": 76.0,
      "vpd": 0.9125,
      "co2": 491
    },
    {
      "time": "14:45:57",
      "side": "west",
      "aperture": 3.6,
      "poreArea": 42.7275,
      "aspectRatio": 0.20978,
      "openRate": 76.19,
      "solar": 487.2,
      "temperature": 28.1,
      "rh": 76.0,
      "vpd": 0.9125,
      "co2": 491
    },
    {
      "time": "14:56:36",
      "side": "west",
      "aperture": 2.9097,
      "poreArea": 31.185,
      "aspectRatio": 0.18318,
      "openRate": 14.286,
      "solar": 456.1,
      "temperature": 26.8,
      "rh": 76.0,
      "vpd": 0.8457,
      "co2": 479
    },
    {
      "time": "14:56:50",
      "side": "west",
      "aperture": 3.5454,
      "poreArea": 44.3475,
      "aspectRatio": 0.20201,
      "openRate": 85.714,
      "solar": 456.1,
      "temperature": 26.8,
      "rh": 76.0,
      "vpd": 0.8457,
      "co2": 479
    },
    {
      "time": "14:56:55",
      "side": "west",
      "aperture": 3.8009,
      "poreArea": 42.5756,
      "aspectRatio": 0.24837,
      "openRate": 86.486,
      "solar": 456.1,
      "temperature": 26.8,
      "rh": 76.0,
      "vpd": 0.8457,
      "co2": 479
    },
    {
      "time": "14:57:51",
      "side": "west",
      "aperture": 3.3438,
      "poreArea": 39.9431,
      "aspectRatio": 0.21364,
      "openRate": 86.957,
      "solar": 455.3,
      "temperature": 26.8,
      "rh": 76.0,
      "vpd": 0.8457,
      "co2": 463
    },
    {
      "time": "14:57:58",
      "side": "west",
      "aperture": 3.3292,
      "poreArea": 34.3238,
      "aspectRatio": 0.25484,
      "openRate": 83.333,
      "solar": 455.3,
      "temperature": 26.8,
      "rh": 76.0,
      "vpd": 0.8457,
      "co2": 463
    },
    {
      "time": "14:58:07",
      "side": "west",
      "aperture": 2.9619,
      "poreArea": 30.0713,
      "aspectRatio": 0.22806,
      "openRate": 66.667,
      "solar": 455.3,
      "temperature": 26.8,
      "rh": 76.0,
      "vpd": 0.8457,
      "co2": 463
    },
    {
      "time": "14:58:18",
      "side": "west",
      "aperture": 3.3437,
      "poreArea": 40.7531,
      "aspectRatio": 0.21483,
      "openRate": 91.304,
      "solar": 455.3,
      "temperature": 26.8,
      "rh": 76.0,
      "vpd": 0.8457,
      "co2": 463
    },
    {
      "time": "15:00:29",
      "side": "west",
      "aperture": 4.4274,
      "poreArea": 49.2075,
      "aspectRatio": 0.28105,
      "openRate": 97.015,
      "solar": 449.4,
      "temperature": 26.6,
      "rh": 76.0,
      "vpd": 0.8358,
      "co2": 463
    },
    {
      "time": "15:00:43",
      "side": "west",
      "aperture": 5.2324,
      "poreArea": 63.585,
      "aspectRatio": 0.30303,
      "openRate": 100.0,
      "solar": 445.2,
      "temperature": 26.6,
      "rh": 74.0,
      "vpd": 0.9055,
      "co2": 463
    },
    {
      "time": "15:01:57",
      "side": "west",
      "aperture": 5.4,
      "poreArea": 66.9263,
      "aspectRatio": 0.33573,
      "openRate": 100.0,
      "solar": 441.0,
      "temperature": 26.5,
      "rh": 74.0,
      "vpd": 0.9001,
      "co2": 463
    },
    {
      "time": "15:01:58",
      "side": "west",
      "aperture": 4.696,
      "poreArea": 55.89,
      "aspectRatio": 0.29362,
      "openRate": 100.0,
      "solar": 441.0,
      "temperature": 26.5,
      "rh": 74.0,
      "vpd": 0.9001,
      "co2": 463
    },
    {
      "time": "15:02:15",
      "side": "west",
      "aperture": 4.9806,
      "poreArea": 62.9775,
      "aspectRatio": 0.28125,
      "openRate": 98.148,
      "solar": 441.0,
      "temperature": 26.5,
      "rh": 74.0,
      "vpd": 0.9001,
      "co2": 463
    },
    {
      "time": "15:02:32",
      "side": "west",
      "aperture": 4.7485,
      "poreArea": 62.37,
      "aspectRatio": 0.27807,
      "openRate": 100.0,
      "solar": 439.3,
      "temperature": 26.5,
      "rh": 75.0,
      "vpd": 0.8655,
      "co2": 463
    },
    {
      "time": "15:02:56",
      "side": "west",
      "aperture": 4.8022,
      "poreArea": 71.685,
      "aspectRatio": 0.26913,
      "openRate": 96.429,
      "solar": 439.3,
      "temperature": 26.5,
      "rh": 75.0,
      "vpd": 0.8655,
      "co2": 463
    },
    {
      "time": "15:06:31",
      "side": "west",
      "aperture": 4.4388,
      "poreArea": 48.6,
      "aspectRatio": 0.26446,
      "openRate": 100.0,
      "solar": 430.9,
      "temperature": 26.2,
      "rh": 76.0,
      "vpd": 0.8163,
      "co2": 457
    },
    {
      "time": "15:06:46",
      "side": "west",
      "aperture": 5.107,
      "poreArea": 59.2313,
      "aspectRatio": 0.31762,
      "openRate": 96.364,
      "solar": 430.9,
      "temperature": 26.2,
      "rh": 76.0,
      "vpd": 0.8163,
      "co2": 457
    },
    {
      "time": "15:06:59",
      "side": "west",
      "aperture": 4.142,
      "poreArea": 48.9038,
      "aspectRatio": 0.25278,
      "openRate": 98.63,
      "solar": 430.9,
      "temperature": 26.2,
      "rh": 76.0,
      "vpd": 0.8163,
      "co2": 457
    },
    {
      "time": "15:07:08",
      "side": "west",
      "aperture": 5.85,
      "poreArea": 73.71,
      "aspectRatio": 0.31659,
      "openRate": 100.0,
      "solar": 430.9,
      "temperature": 26.2,
      "rh": 76.0,
      "vpd": 0.8163,
      "co2": 457
    },
    {
      "time": "15:07:24",
      "side": "west",
      "aperture": 3.6,
      "poreArea": 37.3612,
      "aspectRatio": 0.26435,
      "openRate": 96.774,
      "solar": 430.9,
      "temperature": 26.2,
      "rh": 76.0,
      "vpd": 0.8163,
      "co2": 457
    },
    {
      "time": "15:12:23",
      "side": "west",
      "aperture": 4.05,
      "poreArea": 47.8912,
      "aspectRatio": 0.25936,
      "openRate": 94.186,
      "solar": 415.8,
      "temperature": 25.9,
      "rh": 76.0,
      "vpd": 0.802,
      "co2": 435
    },
    {
      "time": "15:12:38",
      "side": "west",
      "aperture": 3.9572,
      "poreArea": 42.6769,
      "aspectRatio": 0.26702,
      "openRate": 95.238,
      "solar": 412.4,
      "temperature": 25.8,
      "rh": 76.0,
      "vpd": 0.7973,
      "co2": 435
    },
    {
      "time": "15:13:07",
      "side": "west",
      "aperture": 3.7889,
      "poreArea": 50.5238,
      "aspectRatio": 0.22266,
      "openRate": 80.488,
      "solar": 412.4,
      "temperature": 25.8,
      "rh": 76.0,
      "vpd": 0.7973,
      "co2": 435
    },
    {
      "time": "15:13:17",
      "side": "west",
      "aperture": 2.8638,
      "poreArea": 30.6788,
      "aspectRatio": 0.19149,
      "openRate": 61.905,
      "solar": 412.4,
      "temperature": 25.8,
      "rh": 76.0,
      "vpd": 0.7973,
      "co2": 435
    },
    {
      "time": "15:14:35",
      "side": "west",
      "aperture": 3.5576,
      "poreArea": 41.0063,
      "aspectRatio": 0.21429,
      "openRate": 97.917,
      "solar": 405.7,
      "temperature": 25.6,
      "rh": 74.0,
      "vpd": 0.8535,
      "co2": 435
    },
    {
      "time": "15:14:43",
      "side": "west",
      "aperture": 3.4764,
      "poreArea": 39.0825,
      "aspectRatio": 0.21462,
      "openRate": 92.308,
      "solar": 405.7,
      "temperature": 25.6,
      "rh": 74.0,
      "vpd": 0.8535,
      "co2": 435
    },
    {
      "time": "15:14:54",
      "side": "west",
      "aperture": 4.4003,
      "poreArea": 54.5738,
      "aspectRatio": 0.23529,
      "openRate": 88.462,
      "solar": 405.7,
      "temperature": 25.6,
      "rh": 74.0,
      "vpd": 0.8535,
      "co2": 435
    },
    {
      "time": "15:16:04",
      "side": "west",
      "aperture": 3.0282,
      "poreArea": 31.3875,
      "aspectRatio": 0.22222,
      "openRate": 72.222,
      "solar": 403.2,
      "temperature": 25.5,
      "rh": 74.0,
      "vpd": 0.8485,
      "co2": 435
    },
    {
      "time": "15:16:15",
      "side": "west",
      "aperture": 3.5851,
      "poreArea": 39.285,
      "aspectRatio": 0.25118,
      "openRate": 98.02,
      "solar": 403.2,
      "temperature": 25.5,
      "rh": 74.0,
      "vpd": 0.8485,
      "co2": 435
    },
    {
      "time": "15:17:01",
      "side": "west",
      "aperture": 4.4548,
      "poreArea": 50.8275,
      "aspectRatio": 0.2859,
      "openRate": 98.4,
      "solar": 401.5,
      "temperature": 25.4,
      "rh": 74.0,
      "vpd": 0.8435,
      "co2": 435
    },
    {
      "time": "15:17:08",
      "side": "west",
      "aperture": 5.1171,
      "poreArea": 63.0788,
      "aspectRatio": 0.30741,
      "openRate": 97.59,
      "solar": 401.5,
      "temperature": 25.4,
      "rh": 74.0,
      "vpd": 0.8435,
      "co2": 435
    },
    {
      "time": "15:17:14",
      "side": "west",
      "aperture": 4.2952,
      "poreArea": 42.6263,
      "aspectRatio": 0.28571,
      "openRate": 95.918,
      "solar": 401.5,
      "temperature": 25.4,
      "rh": 74.0,
      "vpd": 0.8435,
      "co2": 435
    },
    {
      "time": "15:17:21",
      "side": "west",
      "aperture": 3.699,
      "poreArea": 32.0963,
      "aspectRatio": 0.24499,
      "openRate": 94.444,
      "solar": 401.5,
      "temperature": 25.4,
      "rh": 74.0,
      "vpd": 0.8435,
      "co2": 435
    },
    {
      "time": "15:17:27",
      "side": "west",
      "aperture": 3.946,
      "poreArea": 46.1194,
      "aspectRatio": 0.23749,
      "openRate": 94.737,
      "solar": 401.5,
      "temperature": 25.4,
      "rh": 74.0,
      "vpd": 0.8435,
      "co2": 435
    },
    {
      "time": "15:17:35",
      "side": "west",
      "aperture": 3.5935,
      "poreArea": 40.6013,
      "aspectRatio": 0.23855,
      "openRate": 96.875,
      "solar": 399.8,
      "temperature": 25.4,
      "rh": 74.0,
      "vpd": 0.8435,
      "co2": 419
    },
    {
      "time": "15:17:53",
      "side": "west",
      "aperture": 4.4404,
      "poreArea": 55.7888,
      "aspectRatio": 0.26429,
      "openRate": 95.652,
      "solar": 399.8,
      "temperature": 25.4,
      "rh": 74.0,
      "vpd": 0.8435,
      "co2": 419
    },
    {
      "time": "15:20:26",
      "side": "west",
      "aperture": 3.5885,
      "poreArea": 42.8794,
      "aspectRatio": 0.20838,
      "openRate": 87.5,
      "solar": 394.8,
      "temperature": 25.5,
      "rh": 74.0,
      "vpd": 0.8485,
      "co2": 419
    },
    {
      "time": "15:20:31",
      "side": "west",
      "aperture": 2.8271,
      "poreArea": 33.3619,
      "aspectRatio": 0.21461,
      "openRate": 85.714,
      "solar": 391.4,
      "temperature": 25.5,
      "rh": 75.0,
      "vpd": 0.8158,
      "co2": 419
    },
    {
      "time": "15:20:36",
      "side": "west",
      "aperture": 3.4552,
      "poreArea": 44.55,
      "aspectRatio": 0.1962,
      "openRate": 78.261,
      "solar": 391.4,
      "temperature": 25.5,
      "rh": 75.0,
      "vpd": 0.8158,
      "co2": 419
    },
    {
      "time": "15:20:43",
      "side": "west",
      "aperture": 4.0853,
      "poreArea": 50.4225,
      "aspectRatio": 0.25532,
      "openRate": 100.0,
      "solar": 391.4,
      "temperature": 25.5,
      "rh": 75.0,
      "vpd": 0.8158,
      "co2": 419
    },
    {
      "time": "15:20:49",
      "side": "west",
      "aperture": 4.2262,
      "poreArea": 59.2313,
      "aspectRatio": 0.25338,
      "openRate": 93.75,
      "solar": 391.4,
      "temperature": 25.5,
      "rh": 75.0,
      "vpd": 0.8158,
      "co2": 419
    },
    {
      "time": "15:43:47",
      "side": "west",
      "aperture": 4.4514,
      "poreArea": 52.65,
      "aspectRatio": 0.28571,
      "openRate": 98.413,
      "solar": 325.9,
      "temperature": 26.9,
      "rh": 74.0,
      "vpd": 0.9216,
      "co2": 367
    },
    {
      "time": "15:43:53",
      "side": "west",
      "aperture": 4.5009,
      "poreArea": 53.055,
      "aspectRatio": 0.28947,
      "openRate": 96.61,
      "solar": 325.9,
      "temperature": 26.9,
      "rh": 74.0,
      "vpd": 0.9216,
      "co2": 367
    },
    {
      "time": "15:44:00",
      "side": "west",
      "aperture": 4.8014,
      "poreArea": 67.4831,
      "aspectRatio": 0.25274,
      "openRate": 90.0,
      "solar": 325.9,
      "temperature": 26.9,
      "rh": 74.0,
      "vpd": 0.9216,
      "co2": 367
    },
    {
      "time": "15:44:15",
      "side": "west",
      "aperture": 2.8638,
      "poreArea": 28.755,
      "aspectRatio": 0.19277,
      "openRate": 83.607,
      "solar": 325.9,
      "temperature": 26.9,
      "rh": 74.0,
      "vpd": 0.9216,
      "co2": 367
    },
    {
      "time": "15:44:33",
      "side": "west",
      "aperture": 5.5155,
      "poreArea": 70.1663,
      "aspectRatio": 0.32055,
      "openRate": 100.0,
      "solar": 321.7,
      "temperature": 26.8,
      "rh": 74.0,
      "vpd": 0.9162,
      "co2": 367
    },
    {
      "time": "15:46:32",
      "side": "west",
      "aperture": 4.5,
      "poreArea": 50.625,
      "aspectRatio": 0.29589,
      "openRate": 96.875,
      "solar": 315.8,
      "temperature": 26.4,
      "rh": 76.0,
      "vpd": 0.826,
      "co2": 367
    },
    {
      "time": "15:46:40",
      "side": "west",
      "aperture": 4.3719,
      "poreArea": 47.385,
      "aspectRatio": 0.30792,
      "openRate": 100.0,
      "solar": 315.8,
      "temperature": 26.4,
      "rh": 76.0,
      "vpd": 0.826,
      "co2": 367
    },
    {
      "time": "15:46:47",
      "side": "west",
      "aperture": 4.5782,
      "poreArea": 47.4863,
      "aspectRatio": 0.3125,
      "openRate": 96.078,
      "solar": 315.8,
      "temperature": 26.4,
      "rh": 76.0,
      "vpd": 0.826,
      "co2": 367
    },
    {
      "time": "15:46:57",
      "side": "west",
      "aperture": 4.6571,
      "poreArea": 55.2825,
      "aspectRatio": 0.29652,
      "openRate": 100.0,
      "solar": 315.8,
      "temperature": 26.4,
      "rh": 76.0,
      "vpd": 0.826,
      "co2": 367
    },
    {
      "time": "15:47:13",
      "side": "west",
      "aperture": 4.6287,
      "poreArea": 68.445,
      "aspectRatio": 0.25512,
      "openRate": 95.833,
      "solar": 315.8,
      "temperature": 26.4,
      "rh": 76.0,
      "vpd": 0.826,
      "co2": 367
    },
    {
      "time": "15:47:20",
      "side": "west",
      "aperture": 4.6365,
      "poreArea": 60.2438,
      "aspectRatio": 0.27235,
      "openRate": 96.552,
      "solar": 315.8,
      "temperature": 26.4,
      "rh": 76.0,
      "vpd": 0.826,
      "co2": 367
    },
    {
      "time": "15:47:32",
      "side": "west",
      "aperture": 5.2963,
      "poreArea": 61.56,
      "aspectRatio": 0.30345,
      "openRate": 98.387,
      "solar": 311.6,
      "temperature": 26.2,
      "rh": 76.0,
      "vpd": 0.8163,
      "co2": 367
    },
    {
      "time": "15:48:10",
      "side": "west",
      "aperture": 4.5,
      "poreArea": 51.84,
      "aspectRatio": 0.30508,
      "openRate": 100.0,
      "solar": 311.6,
      "temperature": 26.2,
      "rh": 76.0,
      "vpd": 0.8163,
      "co2": 367
    },
    {
      "time": "15:50:52",
      "side": "west",
      "aperture": 3.8587,
      "poreArea": 43.8413,
      "aspectRatio": 0.25,
      "openRate": 90.0,
      "solar": 303.2,
      "temperature": 25.6,
      "rh": 76.0,
      "vpd": 0.7879,
      "co2": 367
    },
    {
      "time": "15:51:12",
      "side": "west",
      "aperture": 3.7334,
      "poreArea": 42.0694,
      "aspectRatio": 0.23,
      "openRate": 88.889,
      "solar": 303.2,
      "temperature": 25.6,
      "rh": 76.0,
      "vpd": 0.7879,
      "co2": 367
    },
    {
      "time": "15:51:23",
      "side": "west",
      "aperture": 2.8174,
      "poreArea": 26.325,
      "aspectRatio": 0.19718,
      "openRate": 35.714,
      "solar": 303.2,
      "temperature": 25.6,
      "rh": 76.0,
      "vpd": 0.7879,
      "co2": 367
    },
    {
      "time": "15:51:35",
      "side": "west",
      "aperture": 3.6916,
      "poreArea": 37.3106,
      "aspectRatio": 0.27571,
      "openRate": 90.909,
      "solar": 297.4,
      "temperature": 25.5,
      "rh": 76.0,
      "vpd": 0.7832,
      "co2": 367
    },
    {
      "time": "15:51:46",
      "side": "west",
      "aperture": 4.5475,
      "poreArea": 55.7381,
      "aspectRatio": 0.29004,
      "openRate": 93.333,
      "solar": 297.4,
      "temperature": 25.5,
      "rh": 76.0,
      "vpd": 0.7832,
      "co2": 367
    },
    {
      "time": "15:53:08",
      "side": "west",
      "aperture": 2.8045,
      "poreArea": 29.2613,
      "aspectRatio": 0.19192,
      "openRate": 65.217,
      "solar": 290.6,
      "temperature": 25.3,
      "rh": 75.0,
      "vpd": 0.8062,
      "co2": 351
    },
    {
      "time": "15:53:14",
      "side": "west",
      "aperture": 3.1307,
      "poreArea": 27.8438,
      "aspectRatio": 0.18421,
      "openRate": 35.0,
      "solar": 290.6,
      "temperature": 25.3,
      "rh": 75.0,
      "vpd": 0.8062,
      "co2": 351
    },
    {
      "time": "15:53:21",
      "side": "west",
      "aperture": 3.6691,
      "poreArea": 37.9688,
      "aspectRatio": 0.21295,
      "openRate": 33.333,
      "solar": 290.6,
      "temperature": 25.3,
      "rh": 75.0,
      "vpd": 0.8062,
      "co2": 351
    },
    {
      "time": "15:53:30",
      "side": "west",
      "aperture": 4.19,
      "poreArea": 53.5613,
      "aspectRatio": 0.23871,
      "openRate": 100.0,
      "solar": 290.6,
      "temperature": 25.3,
      "rh": 75.0,
      "vpd": 0.8062,
      "co2": 351
    },
    {
      "time": "15:54:55",
      "side": "west",
      "aperture": 4.7337,
      "poreArea": 58.5731,
      "aspectRatio": 0.25956,
      "openRate": 98.795,
      "solar": 287.3,
      "temperature": 25.1,
      "rh": 73.0,
      "vpd": 0.8604,
      "co2": 351
    },
    {
      "time": "15:55:10",
      "side": "west",
      "aperture": 4.5385,
      "poreArea": 53.1562,
      "aspectRatio": 0.26304,
      "openRate": 95.652,
      "solar": 287.3,
      "temperature": 25.1,
      "rh": 73.0,
      "vpd": 0.8604,
      "co2": 351
    },
    {
      "time": "15:55:16",
      "side": "west",
      "aperture": 4.9806,
      "poreArea": 60.4463,
      "aspectRatio": 0.28333,
      "openRate": 100.0,
      "solar": 287.3,
      "temperature": 25.1,
      "rh": 73.0,
      "vpd": 0.8604,
      "co2": 351
    },
    {
      "time": "15:55:22",
      "side": "west",
      "aperture": 4.1464,
      "poreArea": 53.7638,
      "aspectRatio": 0.23045,
      "openRate": 100.0,
      "solar": 287.3,
      "temperature": 25.1,
      "rh": 73.0,
      "vpd": 0.8604,
      "co2": 351
    },
    {
      "time": "15:56:59",
      "side": "west",
      "aperture": 3.6,
      "poreArea": 44.0438,
      "aspectRatio": 0.2254,
      "openRate": 81.579,
      "solar": 280.6,
      "temperature": 25.0,
      "rh": 72.0,
      "vpd": 0.887,
      "co2": 351
    },
    {
      "time": "15:57:21",
      "side": "west",
      "aperture": 4.6179,
      "poreArea": 55.3837,
      "aspectRatio": 0.27115,
      "openRate": 83.333,
      "solar": 280.6,
      "temperature": 25.0,
      "rh": 72.0,
      "vpd": 0.887,
      "co2": 351
    },
    {
      "time": "15:57:37",
      "side": "west",
      "aperture": 4.2691,
      "poreArea": 33.3113,
      "aspectRatio": 0.36585,
      "openRate": 50.0,
      "solar": 276.4,
      "temperature": 25.0,
      "rh": 73.0,
      "vpd": 0.8553,
      "co2": 351
    },
    {
      "time": "15:57:47",
      "side": "west",
      "aperture": 2.8377,
      "poreArea": 25.3125,
      "aspectRatio": 0.23651,
      "openRate": 20.0,
      "solar": 276.4,
      "temperature": 25.0,
      "rh": 73.0,
      "vpd": 0.8553,
      "co2": 351
    },
    {
      "time": "15:59:28",
      "side": "west",
      "aperture": 3.5002,
      "poreArea": 39.3863,
      "aspectRatio": 0.23571,
      "openRate": 77.273,
      "solar": 274.7,
      "temperature": 25.0,
      "rh": 74.0,
      "vpd": 0.8236,
      "co2": 351
    },
    {
      "time": "15:59:47",
      "side": "west",
      "aperture": 3.4212,
      "poreArea": 37.1588,
      "aspectRatio": 0.23636,
      "openRate": 46.875,
      "solar": 272.2,
      "temperature": 25.0,
      "rh": 74.0,
      "vpd": 0.8236,
      "co2": 351
    },
    {
      "time": "15:59:54",
      "side": "west",
      "aperture": 2.6791,
      "poreArea": 24.3,
      "aspectRatio": 0.19718,
      "openRate": 63.636,
      "solar": 272.2,
      "temperature": 25.0,
      "rh": 74.0,
      "vpd": 0.8236,
      "co2": 351
    },
    {
      "time": "16:00:01",
      "side": "west",
      "aperture": 3.1771,
      "poreArea": 36.045,
      "aspectRatio": 0.18723,
      "openRate": 78.947,
      "solar": 272.2,
      "temperature": 25.0,
      "rh": 74.0,
      "vpd": 0.8236,
      "co2": 351
    },
    {
      "time": "16:01:38",
      "side": "west",
      "aperture": 3.2512,
      "poreArea": 37.3613,
      "aspectRatio": 0.19613,
      "openRate": 55.696,
      "solar": 265.4,
      "temperature": 24.8,
      "rh": 74.0,
      "vpd": 0.8139,
      "co2": 351
    },
    {
      "time": "16:02:30",
      "side": "west",
      "aperture": 2.88,
      "poreArea": 35.0325,
      "aspectRatio": 0.19048,
      "openRate": 65.152,
      "solar": 265.4,
      "temperature": 24.8,
      "rh": 74.0,
      "vpd": 0.8139,
      "co2": 351
    },
    {
      "time": "16:02:56",
      "side": "west",
      "aperture": 3.7108,
      "poreArea": 38.7788,
      "aspectRatio": 0.23252,
      "openRate": 82.143,
      "solar": 263.8,
      "temperature": 24.6,
      "rh": 74.0,
      "vpd": 0.8042,
      "co2": 351
    },
    {
      "time": "16:03:18",
      "side": "west",
      "aperture": 4.3554,
      "poreArea": 55.485,
      "aspectRatio": 0.23106,
      "openRate": 96.774,
      "solar": 263.8,
      "temperature": 24.6,
      "rh": 74.0,
      "vpd": 0.8042,
      "co2": 351
    },
    {
      "time": "16:03:51",
      "side": "west",
      "aperture": 3.7395,
      "poreArea": 41.8162,
      "aspectRatio": 0.21759,
      "openRate": 89.286,
      "solar": 260.0,
      "temperature": 24.3,
      "rh": 73.5,
      "vpd": 0.8051,
      "co2": 351
    },
    {
      "time": "16:04:01",
      "side": "west",
      "aperture": 3.4439,
      "poreArea": 36.5513,
      "aspectRatio": 0.21739,
      "openRate": 85.965,
      "solar": 260.0,
      "temperature": 24.3,
      "rh": 73.5,
      "vpd": 0.8051,
      "co2": 351
    },
    {
      "time": "16:04:14",
      "side": "west",
      "aperture": 2.5456,
      "poreArea": 27.945,
      "aspectRatio": 0.16667,
      "openRate": 10.87,
      "solar": 260.0,
      "temperature": 24.3,
      "rh": 73.5,
      "vpd": 0.8051,
      "co2": 351
    },
    {
      "time": "16:05:51",
      "side": "west",
      "aperture": 4.6931,
      "poreArea": 39.69,
      "aspectRatio": 0.40187,
      "openRate": 3.333,
      "solar": 251.2,
      "temperature": 23.5,
      "rh": 73.0,
      "vpd": 0.7818,
      "co2": 351
    },
    {
      "time": "16:06:24",
      "side": "west",
      "aperture": 2.9062,
      "poreArea": 28.9069,
      "aspectRatio": 0.17702,
      "openRate": 20.69,
      "solar": 251.2,
      "temperature": 23.5,
      "rh": 73.0,
      "vpd": 0.7818,
      "co2": 351
    },
    {
      "time": "16:06:58",
      "side": "west",
      "aperture": 2.9247,
      "poreArea": 30.78,
      "aspectRatio": 0.21986,
      "openRate": 32.353,
      "solar": 247.0,
      "temperature": 23.2,
      "rh": 74.0,
      "vpd": 0.7393,
      "co2": 351
    },
    {
      "time": "16:07:58",
      "side": "west",
      "aperture": 3.4212,
      "poreArea": 48.0938,
      "aspectRatio": 0.19522,
      "openRate": 44.118,
      "solar": 244.4,
      "temperature": 23.0,
      "rh": 75.0,
      "vpd": 0.7024,
      "co2": 351
    },
    {
      "time": "16:08:10",
      "side": "west",
      "aperture": 2.9219,
      "poreArea": 36.045,
      "aspectRatio": 0.18343,
      "openRate": 64.706,
      "solar": 244.4,
      "temperature": 23.0,
      "rh": 75.0,
      "vpd": 0.7024,
      "co2": 351
    },
    {
      "time": "16:08:18",
      "side": "west",
      "aperture": 2.8942,
      "poreArea": 41.3606,
      "aspectRatio": 0.17696,
      "openRate": 41.667,
      "solar": 244.4,
      "temperature": 23.0,
      "rh": 75.0,
      "vpd": 0.7024,
      "co2": 351
    },
    {
      "time": "16:08:24",
      "side": "west",
      "aperture": 2.7367,
      "poreArea": 31.995,
      "aspectRatio": 0.17972,
      "openRate": 41.935,
      "solar": 244.4,
      "temperature": 23.0,
      "rh": 75.0,
      "vpd": 0.7024,
      "co2": 351
    },
    {
      "time": "16:09:46",
      "side": "west",
      "aperture": 3.0187,
      "poreArea": 32.9062,
      "aspectRatio": 0.2013,
      "openRate": 81.818,
      "solar": 236.9,
      "temperature": 22.6,
      "rh": 76.0,
      "vpd": 0.6581,
      "co2": 351
    },
    {
      "time": "16:10:27",
      "side": "west",
      "aperture": 2.9329,
      "poreArea": 31.2863,
      "aspectRatio": 0.18604,
      "openRate": 30.769,
      "solar": 236.9,
      "temperature": 22.6,
      "rh": 76.0,
      "vpd": 0.6581,
      "co2": 351
    },
    {
      "time": "16:11:07",
      "side": "west",
      "aperture": 3.42,
      "poreArea": 42.8287,
      "aspectRatio": 0.2151,
      "openRate": 91.667,
      "solar": 232.7,
      "temperature": 22.5,
      "rh": 75.0,
      "vpd": 0.6814,
      "co2": 351
    },
    {
      "time": "16:11:17",
      "side": "west",
      "aperture": 2.6853,
      "poreArea": 34.6275,
      "aspectRatio": 0.18542,
      "openRate": 62.069,
      "solar": 232.7,
      "temperature": 22.5,
      "rh": 75.0,
      "vpd": 0.6814,
      "co2": 351
    },
    {
      "time": "16:12:32",
      "side": "west",
      "aperture": 3.4151,
      "poreArea": 39.6394,
      "aspectRatio": 0.19767,
      "openRate": 59.259,
      "solar": 224.3,
      "temperature": 22.4,
      "rh": 73.0,
      "vpd": 0.7315,
      "co2": 351
    },
    {
      "time": "16:12:39",
      "side": "west",
      "aperture": 3.5043,
      "poreArea": 43.335,
      "aspectRatio": 0.22876,
      "openRate": 74.194,
      "solar": 224.3,
      "temperature": 22.4,
      "rh": 73.0,
      "vpd": 0.7315,
      "co2": 351
    },
    {
      "time": "16:13:33",
      "side": "west",
      "aperture": 3.4139,
      "poreArea": 41.0569,
      "aspectRatio": 0.2053,
      "openRate": 91.228,
      "solar": 218.4,
      "temperature": 22.3,
      "rh": 70.0,
      "vpd": 0.8078,
      "co2": 351
    },
    {
      "time": "16:13:46",
      "side": "west",
      "aperture": 3.0436,
      "poreArea": 41.6138,
      "aspectRatio": 0.16667,
      "openRate": 58.621,
      "solar": 218.4,
      "temperature": 22.3,
      "rh": 70.0,
      "vpd": 0.8078,
      "co2": 351
    },
    {
      "time": "16:13:54",
      "side": "west",
      "aperture": 2.8719,
      "poreArea": 35.5388,
      "aspectRatio": 0.17287,
      "openRate": 60.465,
      "solar": 218.4,
      "temperature": 22.3,
      "rh": 70.0,
      "vpd": 0.8078,
      "co2": 351
    },
    {
      "time": "16:14:06",
      "side": "west",
      "aperture": 3.5561,
      "poreArea": 46.7775,
      "aspectRatio": 0.20065,
      "openRate": 73.684,
      "solar": 218.4,
      "temperature": 22.3,
      "rh": 70.0,
      "vpd": 0.8078,
      "co2": 351
    },
    {
      "time": "16:17:44",
      "side": "west",
      "aperture": 2.6926,
      "poreArea": 30.8306,
      "aspectRatio": 0.1889,
      "openRate": 16.667,
      "solar": 201.6,
      "temperature": 22.2,
      "rh": 68.0,
      "vpd": 0.8564,
      "co2": 363
    },
    {
      "time": "16:17:50",
      "side": "west",
      "aperture": 2.5462,
      "poreArea": 21.9206,
      "aspectRatio": 0.17724,
      "openRate": 15.686,
      "solar": 201.6,
      "temperature": 22.2,
      "rh": 68.0,
      "vpd": 0.8564,
      "co2": 363
    },
    {
      "time": "16:18:00",
      "side": "west",
      "aperture": 2.4581,
      "poreArea": 22.7812,
      "aspectRatio": 0.17519,
      "openRate": 30.769,
      "solar": 201.6,
      "temperature": 22.2,
      "rh": 68.0,
      "vpd": 0.8564,
      "co2": 363
    },
    {
      "time": "16:18:06",
      "side": "west",
      "aperture": 2.3064,
      "poreArea": 28.755,
      "aspectRatio": 0.14123,
      "openRate": 30.769,
      "solar": 201.6,
      "temperature": 22.2,
      "rh": 68.0,
      "vpd": 0.8564,
      "co2": 363
    },
    {
      "time": "16:19:18",
      "side": "west",
      "aperture": 2.7333,
      "poreArea": 30.375,
      "aspectRatio": 0.179,
      "openRate": 33.333,
      "solar": 190.7,
      "temperature": 22.2,
      "rh": 67.0,
      "vpd": 0.8832,
      "co2": 363
    },
    {
      "time": "16:19:45",
      "side": "west",
      "aperture": 2.6881,
      "poreArea": 22.0725,
      "aspectRatio": 0.14856,
      "openRate": 16.667,
      "solar": 193.2,
      "temperature": 22.1,
      "rh": 66.0,
      "vpd": 0.9044,
      "co2": 363
    },
    {
      "time": "16:20:35",
      "side": "west",
      "aperture": 3.7943,
      "poreArea": 37.5637,
      "aspectRatio": 0.28206,
      "openRate": 10.0,
      "solar": 190.7,
      "temperature": 22.1,
      "rh": 66.0,
      "vpd": 0.9044,
      "co2": 351
    },
    {
      "time": "16:20:49",
      "side": "west",
      "aperture": 3.6318,
      "poreArea": 46.575,
      "aspectRatio": 0.18687,
      "openRate": 66.667,
      "solar": 190.7,
      "temperature": 22.1,
      "rh": 66.0,
      "vpd": 0.9044,
      "co2": 351
    },
    {
      "time": "16:23:01",
      "side": "west",
      "aperture": 3.4886,
      "poreArea": 39.3863,
      "aspectRatio": 0.21071,
      "openRate": 93.617,
      "solar": 175.6,
      "temperature": 22.0,
      "rh": 66.0,
      "vpd": 0.8989,
      "co2": 363
    },
    {
      "time": "16:23:51",
      "side": "west",
      "aperture": 2.3192,
      "poreArea": 22.7812,
      "aspectRatio": 0.15789,
      "openRate": 50.0,
      "solar": 173.9,
      "temperature": 22.0,
      "rh": 64.0,
      "vpd": 0.9518,
      "co2": 363
    },
    {
      "time": "16:24:03",
      "side": "west",
      "aperture": 2.9375,
      "poreArea": 29.0081,
      "aspectRatio": 0.20991,
      "openRate": 18.182,
      "solar": 173.9,
      "temperature": 22.0,
      "rh": 64.0,
      "vpd": 0.9518,
      "co2": 363
    },
    {
      "time": "16:32:01",
      "side": "west",
      "aperture": 3.0916,
      "poreArea": 32.0456,
      "aspectRatio": 0.1956,
      "openRate": 25.0,
      "solar": 145.3,
      "temperature": 21.6,
      "rh": 64.0,
      "vpd": 0.9289,
      "co2": 363
    },
    {
      "time": "16:32:31",
      "side": "west",
      "aperture": 2.581,
      "poreArea": 26.3756,
      "aspectRatio": 0.17745,
      "openRate": 11.765,
      "solar": 140.3,
      "temperature": 21.6,
      "rh": 64.0,
      "vpd": 0.9289,
      "co2": 363
    },
    {
      "time": "16:32:44",
      "side": "west",
      "aperture": 1.9398,
      "poreArea": 14.58,
      "aspectRatio": 0.27604,
      "openRate": 25.0,
      "solar": 140.3,
      "temperature": 21.6,
      "rh": 64.0,
      "vpd": 0.9289,
      "co2": 363
    },
    {
      "time": "16:33:43",
      "side": "west",
      "aperture": 3.0187,
      "poreArea": 29.3625,
      "aspectRatio": 0.18421,
      "openRate": 31.25,
      "solar": 134.4,
      "temperature": 21.6,
      "rh": 64.0,
      "vpd": 0.9289,
      "co2": 367
    },
    {
      "time": "16:33:54",
      "side": "west",
      "aperture": 3.9337,
      "poreArea": 48.4988,
      "aspectRatio": 0.24129,
      "openRate": 45.0,
      "solar": 134.4,
      "temperature": 21.6,
      "rh": 64.0,
      "vpd": 0.9289,
      "co2": 367
    },
    {
      "time": "16:42:42",
      "side": "west",
      "aperture": 3.9938,
      "poreArea": 62.4713,
      "aspectRatio": 0.17778,
      "openRate": 100.0,
      "solar": 27.7,
      "temperature": 20.9,
      "rh": 60.0,
      "vpd": 0.9887,
      "co2": 367
    },
    {
      "time": "16:42:49",
      "side": "west",
      "aperture": 3.3206,
      "poreArea": 40.0444,
      "aspectRatio": 0.2083,
      "openRate": 18.182,
      "solar": 27.7,
      "temperature": 20.9,
      "rh": 60.0,
      "vpd": 0.9887,
      "co2": 367
    },
    {
      "time": "16:42:57",
      "side": "west",
      "aperture": 2.6712,
      "poreArea": 17.415,
      "aspectRatio": 0.25806,
      "openRate": 21.429,
      "solar": 27.7,
      "temperature": 20.9,
      "rh": 60.0,
      "vpd": 0.9887,
      "co2": 367
    },
    {
      "time": "16:48:20",
      "side": "west",
      "aperture": 2.5456,
      "poreArea": 25.515,
      "aspectRatio": 0.17143,
      "openRate": 68.421,
      "solar": 21.8,
      "temperature": 20.5,
      "rh": 60.0,
      "vpd": 0.9647,
      "co2": 379
    },
    {
      "time": "16:48:36",
      "side": "west",
      "aperture": 3.2602,
      "poreArea": 36.2475,
      "aspectRatio": 0.20588,
      "openRate": 67.308,
      "solar": 21.8,
      "temperature": 20.5,
      "rh": 60.0,
      "vpd": 0.9647,
      "co2": 379
    },
    {
      "time": "16:56:08",
      "side": "west",
      "aperture": 3.8396,
      "poreArea": 42.4237,
      "aspectRatio": 0.19833,
      "openRate": 10.526,
      "solar": 16.8,
      "temperature": 20.1,
      "rh": 58.0,
      "vpd": 0.9882,
      "co2": 379
    },
    {
      "time": "16:56:40",
      "side": "west",
      "aperture": 2.5494,
      "poreArea": 45.0562,
      "aspectRatio": 0.09803,
      "openRate": 4.167,
      "solar": 16.8,
      "temperature": 20.0,
      "rh": 58.0,
      "vpd": 0.9821,
      "co2": 379
    },
    {
      "time": "16:56:44",
      "side": "west",
      "aperture": 2.7895,
      "poreArea": 26.4263,
      "aspectRatio": 0.22727,
      "openRate": 11.765,
      "solar": 16.8,
      "temperature": 20.0,
      "rh": 58.0,
      "vpd": 0.9821,
      "co2": 379
    },
    {
      "time": "17:09:06",
      "side": "west",
      "aperture": 2.7,
      "poreArea": 28.9575,
      "aspectRatio": 0.20938,
      "openRate": 28.125,
      "solar": 0.0,
      "temperature": 18.5,
      "rh": 52.0,
      "vpd": 1.0223,
      "co2": 399
    },
    {
      "time": "17:09:40",
      "side": "west",
      "aperture": 2.5426,
      "poreArea": 33.6656,
      "aspectRatio": 0.15832,
      "openRate": 27.273,
      "solar": 0.0,
      "temperature": 18.3,
      "rh": 53.0,
      "vpd": 0.9885,
      "co2": 407
    },
    {
      "time": "17:19:53",
      "side": "west",
      "aperture": 2.8301,
      "poreArea": 36.5513,
      "aspectRatio": 0.14124,
      "openRate": 7.5,
      "solar": 0.0,
      "temperature": 16.1,
      "rh": 61.0,
      "vpd": 0.7137,
      "co2": 423
    },
    {
      "time": "17:20:05",
      "side": "west",
      "aperture": 2.7656,
      "poreArea": 37.9688,
      "aspectRatio": 0.14634,
      "openRate": 6.667,
      "solar": 0.0,
      "temperature": 16.1,
      "rh": 61.0,
      "vpd": 0.7137,
      "co2": 423
    },
    {
      "time": "17:20:13",
      "side": "west",
      "aperture": 3.6138,
      "poreArea": 38.1713,
      "aspectRatio": 0.20229,
      "openRate": 30.769,
      "solar": 0.0,
      "temperature": 16.1,
      "rh": 61.0,
      "vpd": 0.7137,
      "co2": 423
    },
    {
      "time": "17:24:35",
      "side": "west",
      "aperture": 3.1168,
      "poreArea": 37.7662,
      "aspectRatio": 0.19834,
      "openRate": 30.769,
      "solar": 0.0,
      "temperature": 15.1,
      "rh": 60.0,
      "vpd": 0.6865,
      "co2": 423
    },
    {
      "time": "17:24:39",
      "side": "west",
      "aperture": 2.6453,
      "poreArea": 24.6038,
      "aspectRatio": 0.16899,
      "openRate": 17.143,
      "solar": 0.0,
      "temperature": 15.1,
      "rh": 60.0,
      "vpd": 0.6865,
      "co2": 423
    }
  ],
  "correlations": {
    "日射量": {
      "all": {
        "n": 489,
        "r": 0.633414,
        "r2": 0.401213
      },
      "east": {
        "n": 285,
        "r": 0.662114,
        "r2": 0.438395
      },
      "west": {
        "n": 204,
        "r": 0.685932,
        "r2": 0.470502
      }
    },
    "温度": {
      "all": {
        "n": 489,
        "r": 0.730674,
        "r2": 0.533884
      },
      "east": {
        "n": 285,
        "r": 0.758377,
        "r2": 0.575136
      },
      "west": {
        "n": 204,
        "r": 0.672224,
        "r2": 0.451886
      }
    },
    "VPD": {
      "all": {
        "n": 489,
        "r": 0.711029,
        "r2": 0.505562
      },
      "east": {
        "n": 285,
        "r": 0.785496,
        "r2": 0.617005
      },
      "west": {
        "n": 204,
        "r": 0.632045,
        "r2": 0.399481
      }
    },
    "湿度": {
      "all": {
        "n": 489,
        "r": 0.091693,
        "r2": 0.008408
      },
      "east": {
        "n": 285,
        "r": 0.281964,
        "r2": 0.079504
      },
      "west": {
        "n": 204,
        "r": -0.212428,
        "r2": 0.045126
      }
    },
    "CO₂": {
      "all": {
        "n": 489,
        "r": -0.347391,
        "r2": 0.120681
      },
      "east": {
        "n": 285,
        "r": -0.472662,
        "r2": 0.223409
      },
      "west": {
        "n": 204,
        "r": -0.093565,
        "r2": 0.008754
      }
    }
  },
  "regressions": {
    "solar": {
      "all": {
        "slope": 0.004489,
        "intercept": 2.0812772,
        "r2": 0.4012133,
        "n": 489
      },
      "east": {
        "slope": 0.0038181,
        "intercept": 2.0119889,
        "r2": 0.4383954,
        "n": 285
      },
      "west": {
        "slope": 0.0055275,
        "intercept": 2.1406783,
        "r2": 0.4705023,
        "n": 204
      }
    },
    "temperature": {
      "all": {
        "slope": 0.1641799,
        "intercept": -0.0868299,
        "r2": 0.5338844,
        "n": 489
      },
      "east": {
        "slope": 0.153155,
        "intercept": 0.2148379,
        "r2": 0.575136,
        "n": 285
      },
      "west": {
        "slope": 0.205171,
        "intercept": -1.2954978,
        "r2": 0.4518857,
        "n": 204
      }
    },
    "vpd": {
      "all": {
        "slope": 2.4224046,
        "intercept": 1.3699592,
        "r2": 0.505562,
        "n": 489
      },
      "east": {
        "slope": 3.0918436,
        "intercept": 0.6426937,
        "r2": 0.6170045,
        "n": 285
      },
      "west": {
        "slope": 1.9611758,
        "intercept": 2.0476905,
        "r2": 0.3994806,
        "n": 204
      }
    }
  },
  "hourlyRegressions": {
    "solar": {
      "all": {
        "slope": 0.0044582,
        "intercept": 2.2323864,
        "r2": 0.6604206,
        "r": 0.8126626,
        "n": 10
      },
      "east": {
        "slope": 0.0049382,
        "intercept": 1.6314696,
        "r2": 0.8523405,
        "r": 0.9232229,
        "n": 5
      },
      "west": {
        "slope": 0.0048423,
        "intercept": 2.4998826,
        "r2": 0.7474288,
        "r": 0.8645397,
        "n": 5
      }
    },
    "temperature": {
      "all": {
        "slope": 0.1683293,
        "intercept": -0.1649069,
        "r2": 0.7893,
        "r": 0.8884256,
        "n": 10
      },
      "east": {
        "slope": 0.1605295,
        "intercept": 0.0716908,
        "r2": 0.8927953,
        "r": 0.9448785,
        "n": 5
      },
      "west": {
        "slope": 0.1795096,
        "intercept": -0.513875,
        "r2": 0.7331688,
        "r": 0.8562528,
        "n": 5
      }
    },
    "vpd": {
      "all": {
        "slope": 2.8819487,
        "intercept": 0.8415877,
        "r2": 0.8938675,
        "r": 0.9454457,
        "n": 10
      },
      "east": {
        "slope": 3.2308044,
        "intercept": 0.50363,
        "r2": 0.9798775,
        "r": 0.9898876,
        "n": 5
      },
      "west": {
        "slope": 2.7416248,
        "intercept": 0.9928728,
        "r2": 0.8522624,
        "r": 0.9231806,
        "n": 5
      }
    }
  },
  "metricComparison": {
    "aperture": {
      "label": "Aperture",
      "metrics": {
        "solar": {
          "label": "日射量",
          "imageR2": 0.4012,
          "hourlyR2": 0.6604,
          "imageN": 489,
          "hourlyN": 10
        },
        "temperature": {
          "label": "温度",
          "imageR2": 0.5339,
          "hourlyR2": 0.7893,
          "imageN": 489,
          "hourlyN": 10
        },
        "vpd": {
          "label": "VPD",
          "imageR2": 0.5056,
          "hourlyR2": 0.8939,
          "imageN": 489,
          "hourlyN": 10
        }
      }
    },
    "poreArea": {
      "label": "Pore Area",
      "metrics": {
        "solar": {
          "label": "日射量",
          "imageR2": 0.3251,
          "hourlyR2": 0.5335,
          "imageN": 489,
          "hourlyN": 10
        },
        "temperature": {
          "label": "温度",
          "imageR2": 0.5077,
          "hourlyR2": 0.7447,
          "imageN": 489,
          "hourlyN": 10
        },
        "vpd": {
          "label": "VPD",
          "imageR2": 0.4994,
          "hourlyR2": 0.8965,
          "imageN": 489,
          "hourlyN": 10
        }
      }
    },
    "aspectRatio": {
      "label": "Short/Long",
      "metrics": {
        "solar": {
          "label": "日射量",
          "imageR2": 0.435,
          "hourlyR2": 0.8483,
          "imageN": 489,
          "hourlyN": 10
        },
        "temperature": {
          "label": "温度",
          "imageR2": 0.4373,
          "hourlyR2": 0.7885,
          "imageN": 489,
          "hourlyN": 10
        },
        "vpd": {
          "label": "VPD",
          "imageR2": 0.3832,
          "hourlyR2": 0.7949,
          "imageN": 489,
          "hourlyN": 10
        }
      }
    }
  },
  "aggregation": [
    {
      "time": "07:00",
      "apertureImageMean": 2.7059,
      "aperturePooledMedian": 2.7896,
      "areaImageMean": 28.3572,
      "areaPooledMedian": 29.4638,
      "aspectImageMean": 0.1877,
      "aspectPooledMedian": 0.1882
    },
    {
      "time": "08:00",
      "apertureImageMean": 2.8141,
      "aperturePooledMedian": 2.8411,
      "areaImageMean": 27.7271,
      "areaPooledMedian": 27.4388,
      "aspectImageMean": 0.2098,
      "aspectPooledMedian": 0.2105
    },
    {
      "time": "09:00",
      "apertureImageMean": 3.5802,
      "aperturePooledMedian": 3.8695,
      "areaImageMean": 38.3886,
      "areaPooledMedian": 41.9681,
      "aspectImageMean": 0.2479,
      "aspectPooledMedian": 0.2567
    },
    {
      "time": "10:00",
      "apertureImageMean": 4.4998,
      "aperturePooledMedian": 4.4415,
      "areaImageMean": 49.5313,
      "areaPooledMedian": 48.8025,
      "aspectImageMean": 0.2963,
      "aspectPooledMedian": 0.2922
    },
    {
      "time": "11:00",
      "apertureImageMean": 5.0201,
      "aperturePooledMedian": 5.0219,
      "areaImageMean": 57.6192,
      "areaPooledMedian": 59.94,
      "aspectImageMean": 0.3256,
      "aspectPooledMedian": 0.3095
    },
    {
      "time": "12:00",
      "apertureImageMean": 5.7504,
      "aperturePooledMedian": 6.39,
      "areaImageMean": 69.1504,
      "areaPooledMedian": 75.9375,
      "aspectImageMean": 0.3519,
      "aspectPooledMedian": 0.3793
    },
    {
      "time": "13:00",
      "apertureImageMean": 6.4828,
      "aperturePooledMedian": 6.5416,
      "areaImageMean": 85.555,
      "areaPooledMedian": 86.8725,
      "aspectImageMean": 0.3523,
      "aspectPooledMedian": 0.3499
    },
    {
      "time": "14:00",
      "apertureImageMean": 4.0779,
      "aperturePooledMedian": 4.2817,
      "areaImageMean": 48.3209,
      "areaPooledMedian": 51.435,
      "aspectImageMean": 0.2546,
      "aspectPooledMedian": 0.2661
    },
    {
      "time": "15:00",
      "apertureImageMean": 4.1353,
      "aperturePooledMedian": 4.2691,
      "areaImageMean": 48.3768,
      "areaPooledMedian": 50.5238,
      "aspectImageMean": 0.259,
      "aspectPooledMedian": 0.2674
    },
    {
      "time": "16:00",
      "apertureImageMean": 3.1142,
      "aperturePooledMedian": 3.182,
      "areaImageMean": 35.3879,
      "areaPooledMedian": 36.7537,
      "aspectImageMean": 0.2002,
      "aspectPooledMedian": 0.1976
    },
    {
      "time": "17:00",
      "apertureImageMean": 2.8877,
      "aperturePooledMedian": 2.7,
      "areaImageMean": 33.9549,
      "areaPooledMedian": 35.64,
      "aspectImageMean": 0.175,
      "aspectPooledMedian": 0.1687
    }
  ],
  "multivariate": {
    "n": 489,
    "r2": 0.5719,
    "standardizedBeta": {
      "solar": 0.0883,
      "vpd": 0.3053,
      "temperature": 0.4344,
      "co2": 0.0533
    }
  },
  "irrigation": {
    "cycles": 20,
    "eventsWithImages": 19,
    "pairedEvents": 17,
    "medianOpenRateChange": -0.1061,
    "medianApertureChange": -0.1604,
    "apertureIncreaseEvents": 5,
    "eventTimes": [
      "07:04",
      "08:31",
      "09:04",
      "09:39",
      "10:16",
      "10:40",
      "10:59",
      "11:20",
      "11:39",
      "11:57",
      "12:14",
      "12:32",
      "12:50",
      "13:09",
      "13:29",
      "13:52",
      "14:23",
      "15:01",
      "16:04",
      "17:04"
    ]
  },
  "phases": [
    {
      "time": "07–09時",
      "title": "Morning activation",
      "description": "Open率 24.7→84.3%。Aperture 2.71→3.58 µm。樹の東面で受光葉を測定。"
    },
    {
      "time": "10–13時",
      "title": "Midday widening",
      "description": "Open率は93〜96%を維持し、Aperture・Area・Short/Longは13時まで増加。"
    },
    {
      "time": "14–17時",
      "title": "Afternoon decline",
      "description": "樹の西面で測定。形状指標が低下し、夕方にはOpen率も19.1%へ低下。"
    }
  ]
};

export const CASE04 = {
  ...DATA,
  images: {
    hero: heroDashboard,
    field: fieldCampaign,
    sampling: samplingDiagram,
    irrigation: irrigationTimeline,
  },
};
